// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file documents/v3alpha/documents.proto (package com.seed.documents.v3alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Empty, Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * Hypermedia resources can have different visibility levels declared by their creators.
 * By default everything is public, because this is what our system started with.
 *
 * Currently, private visibility means the resource is accessible by the owner of the account an its collaborators with WRITER role.
 *
 * @generated from enum com.seed.documents.v3alpha.ResourceVisibility
 */
export enum ResourceVisibility {
  /**
   * @generated from enum value: RESOURCE_VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOURCE_VISIBILITY_PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * @generated from enum value: RESOURCE_VISIBILITY_PRIVATE = 2;
   */
  PRIVATE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ResourceVisibility)
proto3.util.setEnumType(ResourceVisibility, "com.seed.documents.v3alpha.ResourceVisibility", [
  { no: 0, name: "RESOURCE_VISIBILITY_UNSPECIFIED" },
  { no: 1, name: "RESOURCE_VISIBILITY_PUBLIC" },
  { no: 2, name: "RESOURCE_VISIBILITY_PRIVATE" },
]);

/**
 * Attrbites that can be used for sorting.
 *
 * @generated from enum com.seed.documents.v3alpha.SortAttribute
 */
export enum SortAttribute {
  /**
   * Sorting by activity time,
   * i.e. time of the latest comment or change.
   *
   * @generated from enum value: ACTIVITY_TIME = 0;
   */
  ACTIVITY_TIME = 0,

  /**
   * Sorting by name/title of the document.
   *
   * @generated from enum value: NAME = 1;
   */
  NAME = 1,

  /**
   * Sorting by path value.
   * When documents from multiple accounts are returned in the same listing,
   * the entire fully-qualified namespaced path is considered,
   * i.e. <account-id>/<path>.
   *
   * @generated from enum value: PATH = 2;
   */
  PATH = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SortAttribute)
proto3.util.setEnumType(SortAttribute, "com.seed.documents.v3alpha.SortAttribute", [
  { no: 0, name: "ACTIVITY_TIME" },
  { no: 1, name: "NAME" },
  { no: 2, name: "PATH" },
]);

/**
 * Built-in document fields that can be used for sorting QueryDocuments.
 *
 * @generated from enum com.seed.documents.v3alpha.BuiltinSortAttribute
 */
export enum BuiltinSortAttribute {
  /**
   * No built-in field specified.
   *
   * @generated from enum value: BUILTIN_SORT_ATTRIBUTE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort by the document name/title.
   *
   * @generated from enum value: BUILTIN_SORT_ATTRIBUTE_NAME = 1;
   */
  NAME = 1,

  /**
   * Sort by the document path.
   *
   * @generated from enum value: BUILTIN_SORT_ATTRIBUTE_PATH = 2;
   */
  PATH = 2,

  /**
   * Sort by document creation time.
   *
   * @generated from enum value: BUILTIN_SORT_ATTRIBUTE_CREATE_TIME = 3;
   */
  CREATE_TIME = 3,

  /**
   * Sort by document last-update time.
   *
   * @generated from enum value: BUILTIN_SORT_ATTRIBUTE_UPDATE_TIME = 4;
   */
  UPDATE_TIME = 4,

  /**
   * Sort by document activity time (latest comment or change).
   *
   * @generated from enum value: BUILTIN_SORT_ATTRIBUTE_ACTIVITY_TIME = 5;
   */
  ACTIVITY_TIME = 5,

  /**
   * Sort by the number of comments on the document.
   *
   * @generated from enum value: BUILTIN_SORT_ATTRIBUTE_COMMENT_COUNT = 6;
   */
  COMMENT_COUNT = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(BuiltinSortAttribute)
proto3.util.setEnumType(BuiltinSortAttribute, "com.seed.documents.v3alpha.BuiltinSortAttribute", [
  { no: 0, name: "BUILTIN_SORT_ATTRIBUTE_UNSPECIFIED" },
  { no: 1, name: "BUILTIN_SORT_ATTRIBUTE_NAME" },
  { no: 2, name: "BUILTIN_SORT_ATTRIBUTE_PATH" },
  { no: 3, name: "BUILTIN_SORT_ATTRIBUTE_CREATE_TIME" },
  { no: 4, name: "BUILTIN_SORT_ATTRIBUTE_UPDATE_TIME" },
  { no: 5, name: "BUILTIN_SORT_ATTRIBUTE_ACTIVITY_TIME" },
  { no: 6, name: "BUILTIN_SORT_ATTRIBUTE_COMMENT_COUNT" },
]);

/**
 * Scalar and container kinds supported by user-defined document attributes.
 *
 * @generated from enum com.seed.documents.v3alpha.DocumentAttributeKind
 */
export enum DocumentAttributeKind {
  /**
   * No attribute kind specified.
   *
   * @generated from enum value: DOCUMENT_ATTRIBUTE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A nested object with child attributes.
   *
   * @generated from enum value: DOCUMENT_ATTRIBUTE_KIND_OBJECT = 1;
   */
  OBJECT = 1,

  /**
   * A string scalar.
   *
   * @generated from enum value: DOCUMENT_ATTRIBUTE_KIND_STRING = 2;
   */
  STRING = 2,

  /**
   * A signed integer scalar.
   *
   * @generated from enum value: DOCUMENT_ATTRIBUTE_KIND_INT = 3;
   */
  INT = 3,

  /**
   * A boolean scalar.
   *
   * @generated from enum value: DOCUMENT_ATTRIBUTE_KIND_BOOL = 4;
   */
  BOOL = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(DocumentAttributeKind)
proto3.util.setEnumType(DocumentAttributeKind, "com.seed.documents.v3alpha.DocumentAttributeKind", [
  { no: 0, name: "DOCUMENT_ATTRIBUTE_KIND_UNSPECIFIED" },
  { no: 1, name: "DOCUMENT_ATTRIBUTE_KIND_OBJECT" },
  { no: 2, name: "DOCUMENT_ATTRIBUTE_KIND_STRING" },
  { no: 3, name: "DOCUMENT_ATTRIBUTE_KIND_INT" },
  { no: 4, name: "DOCUMENT_ATTRIBUTE_KIND_BOOL" },
]);

/**
 * Request for getting a single document.
 *
 * @generated from message com.seed.documents.v3alpha.GetDocumentRequest
 */
export class GetDocumentRequest extends Message<GetDocumentRequest> {
  /**
   * Required. The ID of the account where the document is located.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path of the document.
   * Empty string means root document.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Optional. Exact version of the document to retrieve.
   * Empty version means "latest".
   *
   * @generated from field: string version = 3;
   */
  version = "";

  constructor(data?: PartialMessage<GetDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDocumentRequest {
    return new GetDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDocumentRequest {
    return new GetDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDocumentRequest {
    return new GetDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDocumentRequest | PlainMessage<GetDocumentRequest> | undefined, b: GetDocumentRequest | PlainMessage<GetDocumentRequest> | undefined): boolean {
    return proto3.util.equals(GetDocumentRequest, a, b);
  }
}

/**
 * When GetDocument RPC fails due to an existing redirect, this message will be attached
 * to the built-in status message's details field. The client should handle the error,
 * and parse this message to follow the redirect.
 * The client must be careful to prevent redirect cycles and very deep redirect chains.
 *
 * @generated from message com.seed.documents.v3alpha.RedirectErrorDetails
 */
export class RedirectErrorDetails extends Message<RedirectErrorDetails> {
  /**
   * Account ID where the redirect points to.
   *
   * @generated from field: string target_account = 1;
   */
  targetAccount = "";

  /**
   * Path of the target document within the target account.
   *
   * @generated from field: string target_path = 2;
   */
  targetPath = "";

  /**
   * Optional. If true, the redirect is a republishing redirect.
   *
   * @generated from field: bool republish = 3;
   */
  republish = false;

  constructor(data?: PartialMessage<RedirectErrorDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.RedirectErrorDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "target_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "republish", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RedirectErrorDetails {
    return new RedirectErrorDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RedirectErrorDetails {
    return new RedirectErrorDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RedirectErrorDetails {
    return new RedirectErrorDetails().fromJsonString(jsonString, options);
  }

  static equals(a: RedirectErrorDetails | PlainMessage<RedirectErrorDetails> | undefined, b: RedirectErrorDetails | PlainMessage<RedirectErrorDetails> | undefined): boolean {
    return proto3.util.equals(RedirectErrorDetails, a, b);
  }
}

/**
 * Request to get document info.
 *
 * @generated from message com.seed.documents.v3alpha.GetDocumentInfoRequest
 */
export class GetDocumentInfoRequest extends Message<GetDocumentInfoRequest> {
  /**
   * Required. Account ID where the document is located.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path of the document.
   * Empty string means root document.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  constructor(data?: PartialMessage<GetDocumentInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetDocumentInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDocumentInfoRequest {
    return new GetDocumentInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDocumentInfoRequest {
    return new GetDocumentInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDocumentInfoRequest {
    return new GetDocumentInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDocumentInfoRequest | PlainMessage<GetDocumentInfoRequest> | undefined, b: GetDocumentInfoRequest | PlainMessage<GetDocumentInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetDocumentInfoRequest, a, b);
  }
}

/**
 * Request to get document info for multiple documents.
 *
 * @generated from message com.seed.documents.v3alpha.BatchGetDocumentInfoRequest
 */
export class BatchGetDocumentInfoRequest extends Message<BatchGetDocumentInfoRequest> {
  /**
   * @generated from field: repeated com.seed.documents.v3alpha.GetDocumentInfoRequest requests = 1;
   */
  requests: GetDocumentInfoRequest[] = [];

  constructor(data?: PartialMessage<BatchGetDocumentInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.BatchGetDocumentInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "requests", kind: "message", T: GetDocumentInfoRequest, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetDocumentInfoRequest {
    return new BatchGetDocumentInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetDocumentInfoRequest {
    return new BatchGetDocumentInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetDocumentInfoRequest {
    return new BatchGetDocumentInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetDocumentInfoRequest | PlainMessage<BatchGetDocumentInfoRequest> | undefined, b: BatchGetDocumentInfoRequest | PlainMessage<BatchGetDocumentInfoRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetDocumentInfoRequest, a, b);
  }
}

/**
 * Response for getting document info for multiple documents.
 *
 * @generated from message com.seed.documents.v3alpha.BatchGetDocumentInfoResponse
 */
export class BatchGetDocumentInfoResponse extends Message<BatchGetDocumentInfoResponse> {
  /**
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentInfo documents = 1;
   */
  documents: DocumentInfo[] = [];

  constructor(data?: PartialMessage<BatchGetDocumentInfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.BatchGetDocumentInfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: DocumentInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetDocumentInfoResponse {
    return new BatchGetDocumentInfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetDocumentInfoResponse {
    return new BatchGetDocumentInfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetDocumentInfoResponse {
    return new BatchGetDocumentInfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetDocumentInfoResponse | PlainMessage<BatchGetDocumentInfoResponse> | undefined, b: BatchGetDocumentInfoResponse | PlainMessage<BatchGetDocumentInfoResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetDocumentInfoResponse, a, b);
  }
}

/**
 * Request to prepare an unsigned document change for client-side signing.
 *
 * @generated from message com.seed.documents.v3alpha.PrepareChangeRequest
 */
export class PrepareChangeRequest extends Message<PrepareChangeRequest> {
  /**
   * Required. The ID of the account where the document is located.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path of the document to create change for.
   * If document doesn't exist it will be created.
   * Empty string means root document.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Required. Version of the document to apply changes to.
   * Can be empty when creating a new document.
   *
   * @generated from field: string base_version = 3;
   */
  baseVersion = "";

  /**
   * Required. Changes to be applied to the document.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentChange changes = 4;
   */
  changes: DocumentChange[] = [];

  /**
   * Optional. ID of the capability that allows the signing key to write on behalf of the account
   * for this particular path.
   *
   * @generated from field: string capability = 5;
   */
  capability = "";

  /**
   * Optional. Visibility of the document.
   * Can only be specified here when creating the document for the first time,
   * i.e. when `base_version` is empty.
   *
   * @generated from field: com.seed.documents.v3alpha.ResourceVisibility visibility = 6;
   */
  visibility = ResourceVisibility.UNSPECIFIED;

  constructor(data?: PartialMessage<PrepareChangeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.PrepareChangeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "base_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "changes", kind: "message", T: DocumentChange, repeated: true },
    { no: 5, name: "capability", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "visibility", kind: "enum", T: proto3.getEnumType(ResourceVisibility) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrepareChangeRequest {
    return new PrepareChangeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrepareChangeRequest {
    return new PrepareChangeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrepareChangeRequest {
    return new PrepareChangeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PrepareChangeRequest | PlainMessage<PrepareChangeRequest> | undefined, b: PrepareChangeRequest | PlainMessage<PrepareChangeRequest> | undefined): boolean {
    return proto3.util.equals(PrepareChangeRequest, a, b);
  }
}

/**
 * Response with prepared change data for client-side signing.
 *
 * @generated from message com.seed.documents.v3alpha.PrepareChangeResponse
 */
export class PrepareChangeResponse extends Message<PrepareChangeResponse> {
  /**
   * The raw CBOR bytes of the Change blob without the signature field.
   * The client must add the signer and signature fields before hashing.
   *
   * @generated from field: bytes unsigned_change = 1;
   */
  unsignedChange = new Uint8Array(0);

  constructor(data?: PartialMessage<PrepareChangeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.PrepareChangeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unsigned_change", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrepareChangeResponse {
    return new PrepareChangeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrepareChangeResponse {
    return new PrepareChangeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrepareChangeResponse {
    return new PrepareChangeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PrepareChangeResponse | PlainMessage<PrepareChangeResponse> | undefined, b: PrepareChangeResponse | PlainMessage<PrepareChangeResponse> | undefined): boolean {
    return proto3.util.equals(PrepareChangeResponse, a, b);
  }
}

/**
 * @generated from message com.seed.documents.v3alpha.DeleteDocumentRequest
 */
export class DeleteDocumentRequest extends Message<DeleteDocumentRequest> {
  /**
   * Required. ID of the account to delete the document from.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path of the document to delete.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  constructor(data?: PartialMessage<DeleteDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DeleteDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteDocumentRequest {
    return new DeleteDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteDocumentRequest {
    return new DeleteDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteDocumentRequest {
    return new DeleteDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteDocumentRequest | PlainMessage<DeleteDocumentRequest> | undefined, b: DeleteDocumentRequest | PlainMessage<DeleteDocumentRequest> | undefined): boolean {
    return proto3.util.equals(DeleteDocumentRequest, a, b);
  }
}

/**
 * Request for listing root documents.
 *
 * @generated from message com.seed.documents.v3alpha.ListRootDocumentsRequest
 */
export class ListRootDocumentsRequest extends Message<ListRootDocumentsRequest> {
  /**
   * Optional. Number of results per page. Default is defined by the server.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize = 0;

  /**
   * Optional. Value from next_page_token obtained from a previous response.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListRootDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListRootDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRootDocumentsRequest {
    return new ListRootDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRootDocumentsRequest {
    return new ListRootDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRootDocumentsRequest {
    return new ListRootDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRootDocumentsRequest | PlainMessage<ListRootDocumentsRequest> | undefined, b: ListRootDocumentsRequest | PlainMessage<ListRootDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(ListRootDocumentsRequest, a, b);
  }
}

/**
 * Response for listing root documents.
 *
 * @generated from message com.seed.documents.v3alpha.ListRootDocumentsResponse
 */
export class ListRootDocumentsResponse extends Message<ListRootDocumentsResponse> {
  /**
   * List of root documents.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentInfo documents = 1;
   */
  documents: DocumentInfo[] = [];

  /**
   * Token for the next page if there're more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListRootDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListRootDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: DocumentInfo, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRootDocumentsResponse {
    return new ListRootDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRootDocumentsResponse {
    return new ListRootDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRootDocumentsResponse {
    return new ListRootDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRootDocumentsResponse | PlainMessage<ListRootDocumentsResponse> | undefined, b: ListRootDocumentsResponse | PlainMessage<ListRootDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(ListRootDocumentsResponse, a, b);
  }
}

/**
 * Request to list accounts.
 *
 * @generated from message com.seed.documents.v3alpha.ListAccountsRequest
 */
export class ListAccountsRequest extends Message<ListAccountsRequest> {
  /**
   * Optional. Number of results to return per page.
   * If not set, the server will pick some default number.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize = 0;

  /**
   * Optional. Token of the page to request, obtained from
   * a previous response.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken = "";

  /**
   * Optional. If set to true, only accounts that the user is subscribed to will be returned.
   * If at least one document in the account has a subscription, then the account is considered subscribed.
   *
   * @generated from field: bool subscribed_only = 3;
   */
  subscribedOnly = false;

  /**
   * Optional. Configuration for sorting the response.
   * If not specified, the default sorting is by activity time in descending order.
   *
   * @generated from field: com.seed.documents.v3alpha.SortOptions sort_options = 4;
   */
  sortOptions?: SortOptions;

  constructor(data?: PartialMessage<ListAccountsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListAccountsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subscribed_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "sort_options", kind: "message", T: SortOptions },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAccountsRequest {
    return new ListAccountsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAccountsRequest {
    return new ListAccountsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAccountsRequest {
    return new ListAccountsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAccountsRequest | PlainMessage<ListAccountsRequest> | undefined, b: ListAccountsRequest | PlainMessage<ListAccountsRequest> | undefined): boolean {
    return proto3.util.equals(ListAccountsRequest, a, b);
  }
}

/**
 * Response to list accounts.
 *
 * @generated from message com.seed.documents.v3alpha.ListAccountsResponse
 */
export class ListAccountsResponse extends Message<ListAccountsResponse> {
  /**
   * List of accounts.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.Account accounts = 1;
   */
  accounts: Account[] = [];

  /**
   * Token for the next page if there're more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListAccountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListAccountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accounts", kind: "message", T: Account, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAccountsResponse {
    return new ListAccountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAccountsResponse {
    return new ListAccountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAccountsResponse {
    return new ListAccountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAccountsResponse | PlainMessage<ListAccountsResponse> | undefined, b: ListAccountsResponse | PlainMessage<ListAccountsResponse> | undefined): boolean {
    return proto3.util.equals(ListAccountsResponse, a, b);
  }
}

/**
 * Request to get a single account by ID.
 *
 * @generated from message com.seed.documents.v3alpha.GetAccountRequest
 */
export class GetAccountRequest extends Message<GetAccountRequest> {
  /**
   * Required. ID of the account to retrieve.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountRequest | PlainMessage<GetAccountRequest> | undefined, b: GetAccountRequest | PlainMessage<GetAccountRequest> | undefined): boolean {
    return proto3.util.equals(GetAccountRequest, a, b);
  }
}

/**
 * Request to get multiple accounts by IDs.
 *
 * @generated from message com.seed.documents.v3alpha.BatchGetAccountsRequest
 */
export class BatchGetAccountsRequest extends Message<BatchGetAccountsRequest> {
  /**
   * Required. List of account IDs to retrieve.
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<BatchGetAccountsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.BatchGetAccountsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetAccountsRequest {
    return new BatchGetAccountsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetAccountsRequest {
    return new BatchGetAccountsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetAccountsRequest {
    return new BatchGetAccountsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetAccountsRequest | PlainMessage<BatchGetAccountsRequest> | undefined, b: BatchGetAccountsRequest | PlainMessage<BatchGetAccountsRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetAccountsRequest, a, b);
  }
}

/**
 * Response to get multiple accounts by IDs.
 *
 * @generated from message com.seed.documents.v3alpha.BatchGetAccountsResponse
 */
export class BatchGetAccountsResponse extends Message<BatchGetAccountsResponse> {
  /**
   * Accounts that were successfully retrieved,
   * keyed by account ID.
   *
   * @generated from field: map<string, com.seed.documents.v3alpha.Account> accounts = 1;
   */
  accounts: { [key: string]: Account } = {};

  /**
   * Errors (if any) that occurred while retrieving accounts,
   * keyed by account ID.
   * The value of the map is a serialized gRPC Status message.
   * It's not used as a concrete type here because it's exposed in a very accessible way,
   * but every gRPC client library has a defined type for the Status message.
   * See https://github.com/googleapis/googleapis/blob/master/google/rpc/status.proto,
   * and https://grpc.io/docs/guides/status-codes.
   *
   * @generated from field: map<string, bytes> errors = 2;
   */
  errors: { [key: string]: Uint8Array } = {};

  constructor(data?: PartialMessage<BatchGetAccountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.BatchGetAccountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accounts", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Account} },
    { no: 2, name: "errors", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 12 /* ScalarType.BYTES */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetAccountsResponse {
    return new BatchGetAccountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetAccountsResponse {
    return new BatchGetAccountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetAccountsResponse {
    return new BatchGetAccountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetAccountsResponse | PlainMessage<BatchGetAccountsResponse> | undefined, b: BatchGetAccountsResponse | PlainMessage<BatchGetAccountsResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetAccountsResponse, a, b);
  }
}

/**
 * Request to update a profile.
 *
 * @generated from message com.seed.documents.v3alpha.UpdateProfileRequest
 */
export class UpdateProfileRequest extends Message<UpdateProfileRequest> {
  /**
   * Required. ID of the account to update the profile for.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. The updated profile data.
   *
   * @generated from field: com.seed.documents.v3alpha.Profile profile = 2;
   */
  profile?: Profile;

  /**
   * Required. Name of the key to use for signing the profile.
   *
   * @generated from field: string signing_key_name = 3;
   */
  signingKeyName = "";

  constructor(data?: PartialMessage<UpdateProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.UpdateProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "profile", kind: "message", T: Profile },
    { no: 3, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProfileRequest {
    return new UpdateProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProfileRequest {
    return new UpdateProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProfileRequest {
    return new UpdateProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProfileRequest | PlainMessage<UpdateProfileRequest> | undefined, b: UpdateProfileRequest | PlainMessage<UpdateProfileRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProfileRequest, a, b);
  }
}

/**
 * Aggregated information about an account.
 * Some of this information comes from the accounts' root document,
 * some is aggregated from the other documents inside of the account.
 *
 * @generated from message com.seed.documents.v3alpha.Account
 */
export class Account extends Message<Account> {
  /**
   * ID of the account.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Metadata attributes from the root document of this account's Space.
   *
   * Deprecated: Use `home_document_info` instead.
   *
   * @generated from field: google.protobuf.Struct metadata = 2;
   */
  metadata?: Struct;

  /**
   * Summary of the activity in the entire account.
   *
   * Deprecated: Use `home_document_info` instead.
   *
   * @generated from field: com.seed.documents.v3alpha.ActivitySummary activity_summary = 3;
   */
  activitySummary?: ActivitySummary;

  /**
   * Whether the user is subscribed to this account.
   * If at least one document in the account has a subscription, then the account is considered subscribed.
   *
   * @generated from field: bool is_subscribed = 4;
   */
  isSubscribed = false;

  /**
   * Optional. ID of another Account this account claims to act on behalf of.
   * If this is present all the other fields should be ignored.
   * It's up to the caller to follow the alias and get the actual account data.
   *
   * @generated from field: string alias_account = 5;
   */
  aliasAccount = "";

  /**
   * Optional. Profile information about the account.
   * Can be missing if there's no Profile blob for this account.
   *
   * @generated from field: com.seed.documents.v3alpha.Profile profile = 6;
   */
  profile?: Profile;

  /**
   * Information about the home document of this account.
   * It can be null if we don't have the home document for this account.
   *
   * @generated from field: com.seed.documents.v3alpha.DocumentInfo home_document_info = 7;
   */
  homeDocumentInfo?: DocumentInfo;

  constructor(data?: PartialMessage<Account>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Account";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: Struct },
    { no: 3, name: "activity_summary", kind: "message", T: ActivitySummary },
    { no: 4, name: "is_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "alias_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "profile", kind: "message", T: Profile },
    { no: 7, name: "home_document_info", kind: "message", T: DocumentInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Account {
    return new Account().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Account {
    return new Account().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Account {
    return new Account().fromJsonString(jsonString, options);
  }

  static equals(a: Account | PlainMessage<Account> | undefined, b: Account | PlainMessage<Account> | undefined): boolean {
    return proto3.util.equals(Account, a, b);
  }
}

/**
 * Profile describes properties of an account.
 *
 * @generated from message com.seed.documents.v3alpha.Profile
 */
export class Profile extends Message<Profile> {
  /**
   * Display name of the account.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * URI for the icon/avatar.
   *
   * @generated from field: string icon = 2;
   */
  icon = "";

  /**
   * Optional short description text.
   *
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * Output only. Time when the profile was updated.
   * This field is set by the server, and is ignored in update requests from the client.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 4;
   */
  updateTime?: Timestamp;

  constructor(data?: PartialMessage<Profile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Profile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "update_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Profile {
    return new Profile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Profile {
    return new Profile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Profile {
    return new Profile().fromJsonString(jsonString, options);
  }

  static equals(a: Profile | PlainMessage<Profile> | undefined, b: Profile | PlainMessage<Profile> | undefined): boolean {
    return proto3.util.equals(Profile, a, b);
  }
}

/**
 * Request to create an alias for a key.
 * There must be an agent capability granted to the signer of the alias.
 *
 * @generated from message com.seed.documents.v3alpha.CreateAliasRequest
 */
export class CreateAliasRequest extends Message<CreateAliasRequest> {
  /**
   * Required. Key to use for signing the alias.
   *
   * @generated from field: string signing_key_name = 1;
   */
  signingKeyName = "";

  /**
   * Required. ID of the target (alias) account.
   *
   * @generated from field: string alias_account = 2;
   */
  aliasAccount = "";

  constructor(data?: PartialMessage<CreateAliasRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.CreateAliasRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "alias_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAliasRequest {
    return new CreateAliasRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAliasRequest {
    return new CreateAliasRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAliasRequest {
    return new CreateAliasRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAliasRequest | PlainMessage<CreateAliasRequest> | undefined, b: CreateAliasRequest | PlainMessage<CreateAliasRequest> | undefined): boolean {
    return proto3.util.equals(CreateAliasRequest, a, b);
  }
}

/**
 * Request to create a contact.
 *
 * @generated from message com.seed.documents.v3alpha.CreateContactRequest
 */
export class CreateContactRequest extends Message<CreateContactRequest> {
  /**
   * Required. ID of the account to create the contact for.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Name of the key to use for signing.
   *
   * @generated from field: string signing_key_name = 2;
   */
  signingKeyName = "";

  /**
   * Required. Account ID about which we are issuing the contact record.
   *
   * @generated from field: string subject = 3;
   */
  subject = "";

  /**
   * Required. Name that we know the subject by.
   *
   * @generated from field: string name = 4;
   */
  name = "";

  constructor(data?: PartialMessage<CreateContactRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.CreateContactRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateContactRequest {
    return new CreateContactRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateContactRequest {
    return new CreateContactRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateContactRequest {
    return new CreateContactRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateContactRequest | PlainMessage<CreateContactRequest> | undefined, b: CreateContactRequest | PlainMessage<CreateContactRequest> | undefined): boolean {
    return proto3.util.equals(CreateContactRequest, a, b);
  }
}

/**
 * Request to get a contact by ID.
 *
 * @generated from message com.seed.documents.v3alpha.GetContactRequest
 */
export class GetContactRequest extends Message<GetContactRequest> {
  /**
   * Required. ID of the contact to retrieve.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetContactRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetContactRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetContactRequest {
    return new GetContactRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetContactRequest {
    return new GetContactRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetContactRequest {
    return new GetContactRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetContactRequest | PlainMessage<GetContactRequest> | undefined, b: GetContactRequest | PlainMessage<GetContactRequest> | undefined): boolean {
    return proto3.util.equals(GetContactRequest, a, b);
  }
}

/**
 * Request to delete a contact.
 *
 * @generated from message com.seed.documents.v3alpha.UpdateContactRequest
 */
export class UpdateContactRequest extends Message<UpdateContactRequest> {
  /**
   * Required. Full snapshot of the updated contact record.
   * Clients should update objects received from GetContact or CreateContact calls.
   * The server will ignore output-only fields like timestamps.
   *
   * @generated from field: com.seed.documents.v3alpha.Contact contact = 1;
   */
  contact?: Contact;

  /**
   * Required. Name of the key to use for signing the contact update.
   *
   * @generated from field: string signing_key_name = 2;
   */
  signingKeyName = "";

  constructor(data?: PartialMessage<UpdateContactRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.UpdateContactRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contact", kind: "message", T: Contact },
    { no: 2, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateContactRequest {
    return new UpdateContactRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateContactRequest {
    return new UpdateContactRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateContactRequest {
    return new UpdateContactRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateContactRequest | PlainMessage<UpdateContactRequest> | undefined, b: UpdateContactRequest | PlainMessage<UpdateContactRequest> | undefined): boolean {
    return proto3.util.equals(UpdateContactRequest, a, b);
  }
}

/**
 * Request to delete a contact.
 *
 * @generated from message com.seed.documents.v3alpha.DeleteContactRequest
 */
export class DeleteContactRequest extends Message<DeleteContactRequest> {
  /**
   * Required. ID of the contact within the account.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Required. Name of the key to use for signing the contact deletion.
   *
   * @generated from field: string signing_key_name = 2;
   */
  signingKeyName = "";

  constructor(data?: PartialMessage<DeleteContactRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DeleteContactRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteContactRequest {
    return new DeleteContactRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteContactRequest {
    return new DeleteContactRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteContactRequest {
    return new DeleteContactRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteContactRequest | PlainMessage<DeleteContactRequest> | undefined, b: DeleteContactRequest | PlainMessage<DeleteContactRequest> | undefined): boolean {
    return proto3.util.equals(DeleteContactRequest, a, b);
  }
}

/**
 * Request to list contacts for an account.
 *
 * @generated from message com.seed.documents.v3alpha.ListContactsRequest
 */
export class ListContactsRequest extends Message<ListContactsRequest> {
  /**
   * Optional. Number of results per page. Default is defined by the server.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize = 0;

  /**
   * Optional. Value from next_page_token obtained from a previous response.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken = "";

  /**
   * Required. Filter for listing contacts.
   *
   * @generated from oneof com.seed.documents.v3alpha.ListContactsRequest.filter
   */
  filter: {
    /**
     * Lists contacts by issuer account key.
     * I.e. lists the contacts that an account has ever issued.
     *
     * @generated from field: string account = 3;
     */
    value: string;
    case: "account";
  } | {
    /**
     * Lists contacts by subject.
     *
     * @generated from field: string subject = 4;
     */
    value: string;
    case: "subject";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ListContactsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListContactsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "filter" },
    { no: 4, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "filter" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListContactsRequest {
    return new ListContactsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListContactsRequest {
    return new ListContactsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListContactsRequest {
    return new ListContactsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListContactsRequest | PlainMessage<ListContactsRequest> | undefined, b: ListContactsRequest | PlainMessage<ListContactsRequest> | undefined): boolean {
    return proto3.util.equals(ListContactsRequest, a, b);
  }
}

/**
 * Response for listing contacts.
 *
 * @generated from message com.seed.documents.v3alpha.ListContactsResponse
 */
export class ListContactsResponse extends Message<ListContactsResponse> {
  /**
   * List of contacts.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.Contact contacts = 1;
   */
  contacts: Contact[] = [];

  /**
   * Token for the next page if there're more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListContactsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListContactsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contacts", kind: "message", T: Contact, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListContactsResponse {
    return new ListContactsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListContactsResponse {
    return new ListContactsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListContactsResponse {
    return new ListContactsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListContactsResponse | PlainMessage<ListContactsResponse> | undefined, b: ListContactsResponse | PlainMessage<ListContactsResponse> | undefined): boolean {
    return proto3.util.equals(ListContactsResponse, a, b);
  }
}

/**
 * Contact information for an account.
 *
 * @generated from message com.seed.documents.v3alpha.Contact
 */
export class Contact extends Message<Contact> {
  /**
   * ID of the contact.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Subject is the account that's being described by the contact record.
   *
   * @generated from field: string subject = 2;
   */
  subject = "";

  /**
   * Name is the public name of the contact that we know them by.
   *
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * Time when the contact was created.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  /**
   * Time when the contact was updated.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 5;
   */
  updateTime?: Timestamp;

  /**
   * Account ID that issued this contact.
   *
   * @generated from field: string account = 6;
   */
  account = "";

  /**
   * Key that signed this contact.
   * When omitted in legacy storage, it matches account.
   *
   * @generated from field: string signer = 7;
   */
  signer = "";

  /**
   * Additional metadata from the contact blob (e.g., following preferences).
   *
   * @generated from field: google.protobuf.Struct metadata = 8;
   */
  metadata?: Struct;

  constructor(data?: PartialMessage<Contact>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Contact";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "create_time", kind: "message", T: Timestamp },
    { no: 5, name: "update_time", kind: "message", T: Timestamp },
    { no: 6, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "metadata", kind: "message", T: Struct },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Contact {
    return new Contact().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Contact {
    return new Contact().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Contact {
    return new Contact().fromJsonString(jsonString, options);
  }

  static equals(a: Contact | PlainMessage<Contact> | undefined, b: Contact | PlainMessage<Contact> | undefined): boolean {
    return proto3.util.equals(Contact, a, b);
  }
}

/**
 * Request to list a directory.
 *
 * @generated from message com.seed.documents.v3alpha.ListDirectoryRequest
 */
export class ListDirectoryRequest extends Message<ListDirectoryRequest> {
  /**
   * Optional. Size of the page.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize = 0;

  /**
   * Optional. Pagination token.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken = "";

  /**
   * Required. ID of the account to list the directory for.
   *
   * @generated from field: string account = 3;
   */
  account = "";

  /**
   * Required. Path of the directory to list documents for.
   * Empty string means root directory.
   *
   * @generated from field: string directory_path = 4;
   */
  directoryPath = "";

  /**
   * Optional. If true, list documents recursively.
   *
   * @generated from field: bool recursive = 5;
   */
  recursive = false;

  /**
   * Optional. If set to true, only documents that the user is subscribed to will be returned.
   *
   * @generated from field: bool subscribed_only = 6;
   */
  subscribedOnly = false;

  /**
   * Optional. Configuration for sorting.
   * If not specified, the default sorting is by activity time in descending order.
   *
   * @generated from field: com.seed.documents.v3alpha.SortOptions sort_options = 7;
   */
  sortOptions?: SortOptions;

  constructor(data?: PartialMessage<ListDirectoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDirectoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "directory_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "recursive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "subscribed_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "sort_options", kind: "message", T: SortOptions },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDirectoryRequest {
    return new ListDirectoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDirectoryRequest {
    return new ListDirectoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDirectoryRequest {
    return new ListDirectoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDirectoryRequest | PlainMessage<ListDirectoryRequest> | undefined, b: ListDirectoryRequest | PlainMessage<ListDirectoryRequest> | undefined): boolean {
    return proto3.util.equals(ListDirectoryRequest, a, b);
  }
}

/**
 * Options for sorting list of documents.
 *
 * @generated from message com.seed.documents.v3alpha.SortOptions
 */
export class SortOptions extends Message<SortOptions> {
  /**
   * Attributes by which the list can be sorted.
   *
   * @generated from field: com.seed.documents.v3alpha.SortAttribute attribute = 1;
   */
  attribute = SortAttribute.ACTIVITY_TIME;

  /**
   * By default sort is ascending (smaller values first).
   * This field can be specified to choose the opposing sorting.
   *
   * @generated from field: bool descending = 2;
   */
  descending = false;

  constructor(data?: PartialMessage<SortOptions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.SortOptions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "attribute", kind: "enum", T: proto3.getEnumType(SortAttribute) },
    { no: 2, name: "descending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SortOptions {
    return new SortOptions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SortOptions {
    return new SortOptions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SortOptions {
    return new SortOptions().fromJsonString(jsonString, options);
  }

  static equals(a: SortOptions | PlainMessage<SortOptions> | undefined, b: SortOptions | PlainMessage<SortOptions> | undefined): boolean {
    return proto3.util.equals(SortOptions, a, b);
  }
}

/**
 * Response of the directory list.
 *
 * @generated from message com.seed.documents.v3alpha.ListDirectoryResponse
 */
export class ListDirectoryResponse extends Message<ListDirectoryResponse> {
  /**
   * List of documents.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentInfo documents = 1;
   */
  documents: DocumentInfo[] = [];

  /**
   * Optional. Token for the next page if there're more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListDirectoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDirectoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: DocumentInfo, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDirectoryResponse {
    return new ListDirectoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDirectoryResponse {
    return new ListDirectoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDirectoryResponse {
    return new ListDirectoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDirectoryResponse | PlainMessage<ListDirectoryResponse> | undefined, b: ListDirectoryResponse | PlainMessage<ListDirectoryResponse> | undefined): boolean {
    return proto3.util.equals(ListDirectoryResponse, a, b);
  }
}

/**
 * Request for listing documents.
 *
 * @generated from message com.seed.documents.v3alpha.ListDocumentsRequest
 */
export class ListDocumentsRequest extends Message<ListDocumentsRequest> {
  /**
   * Optional. ID of the account to list documents for.
   * If not specified, all documents are listed.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Optional. Number of results per page. Default is defined by the server.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * Optional. Value from next_page_token obtained from a previous response.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentsRequest {
    return new ListDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentsRequest {
    return new ListDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentsRequest {
    return new ListDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentsRequest | PlainMessage<ListDocumentsRequest> | undefined, b: ListDocumentsRequest | PlainMessage<ListDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(ListDocumentsRequest, a, b);
  }
}

/**
 * Response with list of documents.
 *
 * @generated from message com.seed.documents.v3alpha.ListDocumentsResponse
 */
export class ListDocumentsResponse extends Message<ListDocumentsResponse> {
  /**
   * List of documents.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentInfo documents = 1;
   */
  documents: DocumentInfo[] = [];

  /**
   * Token for the next page if there're more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: DocumentInfo, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentsResponse {
    return new ListDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentsResponse {
    return new ListDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentsResponse {
    return new ListDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentsResponse | PlainMessage<ListDocumentsResponse> | undefined, b: ListDocumentsResponse | PlainMessage<ListDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(ListDocumentsResponse, a, b);
  }
}

/**
 * Request for listing unreferenced documents in a site.
 *
 * @generated from message com.seed.documents.v3alpha.ListUnreferencedDocumentsRequest
 */
export class ListUnreferencedDocumentsRequest extends Message<ListUnreferencedDocumentsRequest> {
  /**
   * Required. ID of the site account.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Optional. Number of results per page. Default is defined by the server.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * Optional. Value from next_page_token obtained from a previous response.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListUnreferencedDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListUnreferencedDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUnreferencedDocumentsRequest {
    return new ListUnreferencedDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUnreferencedDocumentsRequest {
    return new ListUnreferencedDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUnreferencedDocumentsRequest {
    return new ListUnreferencedDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListUnreferencedDocumentsRequest | PlainMessage<ListUnreferencedDocumentsRequest> | undefined, b: ListUnreferencedDocumentsRequest | PlainMessage<ListUnreferencedDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(ListUnreferencedDocumentsRequest, a, b);
  }
}

/**
 * Response with unreferenced documents.
 *
 * @generated from message com.seed.documents.v3alpha.ListUnreferencedDocumentsResponse
 */
export class ListUnreferencedDocumentsResponse extends Message<ListUnreferencedDocumentsResponse> {
  /**
   * Published documents not covered by their immediate parent.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentInfo documents = 1;
   */
  documents: DocumentInfo[] = [];

  /**
   * Token for the next page if there are more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  /**
   * True while one or more current parents have not been indexed successfully.
   *
   * @generated from field: bool index_incomplete = 3;
   */
  indexIncomplete = false;

  constructor(data?: PartialMessage<ListUnreferencedDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListUnreferencedDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: DocumentInfo, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "index_incomplete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUnreferencedDocumentsResponse {
    return new ListUnreferencedDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUnreferencedDocumentsResponse {
    return new ListUnreferencedDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUnreferencedDocumentsResponse {
    return new ListUnreferencedDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListUnreferencedDocumentsResponse | PlainMessage<ListUnreferencedDocumentsResponse> | undefined, b: ListUnreferencedDocumentsResponse | PlainMessage<ListUnreferencedDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(ListUnreferencedDocumentsResponse, a, b);
  }
}

/**
 * A typed scalar document attribute value.
 *
 * @generated from message com.seed.documents.v3alpha.AttributeValue
 */
export class AttributeValue extends Message<AttributeValue> {
  /**
   * @generated from oneof com.seed.documents.v3alpha.AttributeValue.value
   */
  value: {
    /**
     * An explicit null value.
     *
     * @generated from field: google.protobuf.Empty null_value = 1;
     */
    value: Empty;
    case: "nullValue";
  } | {
    /**
     * A string value.
     *
     * @generated from field: string string_value = 2;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * A signed integer value.
     *
     * @generated from field: int64 int_value = 3;
     */
    value: bigint;
    case: "intValue";
  } | {
    /**
     * A boolean value.
     *
     * @generated from field: bool bool_value = 4;
     */
    value: boolean;
    case: "boolValue";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<AttributeValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.AttributeValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "null_value", kind: "message", T: Empty, oneof: "value" },
    { no: 2, name: "string_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
    { no: 3, name: "int_value", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "value" },
    { no: 4, name: "bool_value", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AttributeValue {
    return new AttributeValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AttributeValue {
    return new AttributeValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AttributeValue {
    return new AttributeValue().fromJsonString(jsonString, options);
  }

  static equals(a: AttributeValue | PlainMessage<AttributeValue> | undefined, b: AttributeValue | PlainMessage<AttributeValue> | undefined): boolean {
    return proto3.util.equals(AttributeValue, a, b);
  }
}

/**
 * A recursive predicate over document attributes and built-in document fields.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter
 */
export class DocumentFilter extends Message<DocumentFilter> {
  /**
   * Predicate to apply.
   *
   * @generated from oneof com.seed.documents.v3alpha.DocumentFilter.filter
   */
  filter: {
    /**
     * Matches when every nested filter matches.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.And and = 1;
     */
    value: DocumentFilter_And;
    case: "and";
  } | {
    /**
     * Matches when any nested filter matches.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.Or or = 2;
     */
    value: DocumentFilter_Or;
    case: "or";
  } | {
    /**
     * Inverts a nested filter.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.Not not = 3;
     */
    value: DocumentFilter_Not;
    case: "not";
  } | {
    /**
     * Compares a user-defined attribute value.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.Comparison comparison = 4;
     */
    value: DocumentFilter_Comparison;
    case: "comparison";
  } | {
    /**
     * Matches when a user-defined attribute exists and is not null.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.Presence exists = 5;
     */
    value: DocumentFilter_Presence;
    case: "exists";
  } | {
    /**
     * Matches when a user-defined attribute is absent or null.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.Presence missing = 6;
     */
    value: DocumentFilter_Presence;
    case: "missing";
  } | {
    /**
     * Matches text within a user-defined string attribute.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.StringMatch string_match = 7;
     */
    value: DocumentFilter_StringMatch;
    case: "stringMatch";
  } | {
    /**
     * Matches the built-in document URL.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.URLMatch url_match = 8;
     */
    value: DocumentFilter_URLMatch;
    case: "urlMatch";
  } | {
    /**
     * Matches the space that owns the document.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.SpaceMatch space_match = 9;
     */
    value: DocumentFilter_SpaceMatch;
    case: "spaceMatch";
  } | {
    /**
     * Matches the document path across accounts.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.PathMatch path_match = 10;
     */
    value: DocumentFilter_PathMatch;
    case: "pathMatch";
  } | {
    /**
     * Matches documents the account is one of the authors of.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.AuthorMatch author_match = 11;
     */
    value: DocumentFilter_AuthorMatch;
    case: "authorMatch";
  } | {
    /**
     * Matches documents whose creation or update time falls within a range.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentFilter.TimeRange time_range = 12;
     */
    value: DocumentFilter_TimeRange;
    case: "timeRange";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<DocumentFilter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "and", kind: "message", T: DocumentFilter_And, oneof: "filter" },
    { no: 2, name: "or", kind: "message", T: DocumentFilter_Or, oneof: "filter" },
    { no: 3, name: "not", kind: "message", T: DocumentFilter_Not, oneof: "filter" },
    { no: 4, name: "comparison", kind: "message", T: DocumentFilter_Comparison, oneof: "filter" },
    { no: 5, name: "exists", kind: "message", T: DocumentFilter_Presence, oneof: "filter" },
    { no: 6, name: "missing", kind: "message", T: DocumentFilter_Presence, oneof: "filter" },
    { no: 7, name: "string_match", kind: "message", T: DocumentFilter_StringMatch, oneof: "filter" },
    { no: 8, name: "url_match", kind: "message", T: DocumentFilter_URLMatch, oneof: "filter" },
    { no: 9, name: "space_match", kind: "message", T: DocumentFilter_SpaceMatch, oneof: "filter" },
    { no: 10, name: "path_match", kind: "message", T: DocumentFilter_PathMatch, oneof: "filter" },
    { no: 11, name: "author_match", kind: "message", T: DocumentFilter_AuthorMatch, oneof: "filter" },
    { no: 12, name: "time_range", kind: "message", T: DocumentFilter_TimeRange, oneof: "filter" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter {
    return new DocumentFilter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter {
    return new DocumentFilter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter {
    return new DocumentFilter().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter | PlainMessage<DocumentFilter> | undefined, b: DocumentFilter | PlainMessage<DocumentFilter> | undefined): boolean {
    return proto3.util.equals(DocumentFilter, a, b);
  }
}

/**
 * Matches when all nested filters match. An empty list matches every document.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.And
 */
export class DocumentFilter_And extends Message<DocumentFilter_And> {
  /**
   * Filters to combine.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentFilter filters = 1;
   */
  filters: DocumentFilter[] = [];

  constructor(data?: PartialMessage<DocumentFilter_And>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.And";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filters", kind: "message", T: DocumentFilter, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_And {
    return new DocumentFilter_And().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_And {
    return new DocumentFilter_And().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_And {
    return new DocumentFilter_And().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_And | PlainMessage<DocumentFilter_And> | undefined, b: DocumentFilter_And | PlainMessage<DocumentFilter_And> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_And, a, b);
  }
}

/**
 * Matches when at least one nested filter matches. An empty list matches no documents.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.Or
 */
export class DocumentFilter_Or extends Message<DocumentFilter_Or> {
  /**
   * Filters to combine.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentFilter filters = 1;
   */
  filters: DocumentFilter[] = [];

  constructor(data?: PartialMessage<DocumentFilter_Or>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.Or";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filters", kind: "message", T: DocumentFilter, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_Or {
    return new DocumentFilter_Or().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_Or {
    return new DocumentFilter_Or().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_Or {
    return new DocumentFilter_Or().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_Or | PlainMessage<DocumentFilter_Or> | undefined, b: DocumentFilter_Or | PlainMessage<DocumentFilter_Or> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_Or, a, b);
  }
}

/**
 * Inverts a nested filter.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.Not
 */
export class DocumentFilter_Not extends Message<DocumentFilter_Not> {
  /**
   * Filter to invert.
   *
   * @generated from field: com.seed.documents.v3alpha.DocumentFilter filter = 1;
   */
  filter?: DocumentFilter;

  constructor(data?: PartialMessage<DocumentFilter_Not>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.Not";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filter", kind: "message", T: DocumentFilter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_Not {
    return new DocumentFilter_Not().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_Not {
    return new DocumentFilter_Not().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_Not {
    return new DocumentFilter_Not().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_Not | PlainMessage<DocumentFilter_Not> | undefined, b: DocumentFilter_Not | PlainMessage<DocumentFilter_Not> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_Not, a, b);
  }
}

/**
 * Compares a user-defined document attribute with a typed value.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.Comparison
 */
export class DocumentFilter_Comparison extends Message<DocumentFilter_Comparison> {
  /**
   * Attribute key to compare.
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * Comparison operator to apply.
   *
   * @generated from field: com.seed.documents.v3alpha.DocumentFilter.Comparison.Operator operator = 2;
   */
  operator = DocumentFilter_Comparison_Operator.OPERATOR_UNSPECIFIED;

  /**
   * Value to compare against.
   *
   * @generated from field: com.seed.documents.v3alpha.AttributeValue value = 3;
   */
  value?: AttributeValue;

  constructor(data?: PartialMessage<DocumentFilter_Comparison>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.Comparison";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "operator", kind: "enum", T: proto3.getEnumType(DocumentFilter_Comparison_Operator) },
    { no: 3, name: "value", kind: "message", T: AttributeValue },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_Comparison {
    return new DocumentFilter_Comparison().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_Comparison {
    return new DocumentFilter_Comparison().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_Comparison {
    return new DocumentFilter_Comparison().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_Comparison | PlainMessage<DocumentFilter_Comparison> | undefined, b: DocumentFilter_Comparison | PlainMessage<DocumentFilter_Comparison> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_Comparison, a, b);
  }
}

/**
 * Supported comparison operators.
 *
 * @generated from enum com.seed.documents.v3alpha.DocumentFilter.Comparison.Operator
 */
export enum DocumentFilter_Comparison_Operator {
  /**
   * No operator specified.
   *
   * @generated from enum value: OPERATOR_UNSPECIFIED = 0;
   */
  OPERATOR_UNSPECIFIED = 0,

  /**
   * Equal to.
   *
   * @generated from enum value: EQUAL = 1;
   */
  EQUAL = 1,

  /**
   * Not equal to.
   *
   * @generated from enum value: NOT_EQUAL = 2;
   */
  NOT_EQUAL = 2,

  /**
   * Less than.
   *
   * @generated from enum value: LESS_THAN = 3;
   */
  LESS_THAN = 3,

  /**
   * Less than or equal to.
   *
   * @generated from enum value: LESS_THAN_OR_EQUAL = 4;
   */
  LESS_THAN_OR_EQUAL = 4,

  /**
   * Greater than.
   *
   * @generated from enum value: GREATER_THAN = 5;
   */
  GREATER_THAN = 5,

  /**
   * Greater than or equal to.
   *
   * @generated from enum value: GREATER_THAN_OR_EQUAL = 6;
   */
  GREATER_THAN_OR_EQUAL = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(DocumentFilter_Comparison_Operator)
proto3.util.setEnumType(DocumentFilter_Comparison_Operator, "com.seed.documents.v3alpha.DocumentFilter.Comparison.Operator", [
  { no: 0, name: "OPERATOR_UNSPECIFIED" },
  { no: 1, name: "EQUAL" },
  { no: 2, name: "NOT_EQUAL" },
  { no: 3, name: "LESS_THAN" },
  { no: 4, name: "LESS_THAN_OR_EQUAL" },
  { no: 5, name: "GREATER_THAN" },
  { no: 6, name: "GREATER_THAN_OR_EQUAL" },
]);

/**
 * Tests whether a user-defined document attribute is present or missing.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.Presence
 */
export class DocumentFilter_Presence extends Message<DocumentFilter_Presence> {
  /**
   * Attribute key to test.
   *
   * @generated from field: string key = 1;
   */
  key = "";

  constructor(data?: PartialMessage<DocumentFilter_Presence>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.Presence";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_Presence {
    return new DocumentFilter_Presence().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_Presence {
    return new DocumentFilter_Presence().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_Presence {
    return new DocumentFilter_Presence().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_Presence | PlainMessage<DocumentFilter_Presence> | undefined, b: DocumentFilter_Presence | PlainMessage<DocumentFilter_Presence> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_Presence, a, b);
  }
}

/**
 * Matches text within a user-defined string attribute.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.StringMatch
 */
export class DocumentFilter_StringMatch extends Message<DocumentFilter_StringMatch> {
  /**
   * Attribute key to search.
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * Text to search for.
   *
   * @generated from field: string value = 2;
   */
  value = "";

  /**
   * Whether matching is case-sensitive.
   *
   * @generated from field: bool case_sensitive = 3;
   */
  caseSensitive = false;

  /**
   * When false, value may occur anywhere. When true, value must be a prefix.
   *
   * @generated from field: bool prefix = 4;
   */
  prefix = false;

  constructor(data?: PartialMessage<DocumentFilter_StringMatch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.StringMatch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "case_sensitive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "prefix", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_StringMatch {
    return new DocumentFilter_StringMatch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_StringMatch {
    return new DocumentFilter_StringMatch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_StringMatch {
    return new DocumentFilter_StringMatch().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_StringMatch | PlainMessage<DocumentFilter_StringMatch> | undefined, b: DocumentFilter_StringMatch | PlainMessage<DocumentFilter_StringMatch> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_StringMatch, a, b);
  }
}

/**
 * Matches the built-in URL of a document.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.URLMatch
 */
export class DocumentFilter_URLMatch extends Message<DocumentFilter_URLMatch> {
  /**
   * Canonical hm:// document URL to match.
   *
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * When false, matches the URL exactly. When true, also matches descendant URLs.
   *
   * @generated from field: bool prefix = 2;
   */
  prefix = false;

  constructor(data?: PartialMessage<DocumentFilter_URLMatch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.URLMatch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prefix", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_URLMatch {
    return new DocumentFilter_URLMatch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_URLMatch {
    return new DocumentFilter_URLMatch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_URLMatch {
    return new DocumentFilter_URLMatch().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_URLMatch | PlainMessage<DocumentFilter_URLMatch> | undefined, b: DocumentFilter_URLMatch | PlainMessage<DocumentFilter_URLMatch> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_URLMatch, a, b);
  }
}

/**
 * Matches the built-in space that owns a document.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.SpaceMatch
 */
export class DocumentFilter_SpaceMatch extends Message<DocumentFilter_SpaceMatch> {
  /**
   * Space principal to match.
   *
   * @generated from field: string space = 1;
   */
  space = "";

  constructor(data?: PartialMessage<DocumentFilter_SpaceMatch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.SpaceMatch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "space", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_SpaceMatch {
    return new DocumentFilter_SpaceMatch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_SpaceMatch {
    return new DocumentFilter_SpaceMatch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_SpaceMatch {
    return new DocumentFilter_SpaceMatch().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_SpaceMatch | PlainMessage<DocumentFilter_SpaceMatch> | undefined, b: DocumentFilter_SpaceMatch | PlainMessage<DocumentFilter_SpaceMatch> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_SpaceMatch, a, b);
  }
}

/**
 * Matches the built-in path of a document, independently of its account.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.PathMatch
 */
export class DocumentFilter_PathMatch extends Message<DocumentFilter_PathMatch> {
  /**
   * Canonical document path. Empty selects account root documents.
   *
   * @generated from field: string path = 1;
   */
  path = "";

  /**
   * When false, matches the path exactly. When true, also matches descendant paths.
   *
   * @generated from field: bool prefix = 2;
   */
  prefix = false;

  constructor(data?: PartialMessage<DocumentFilter_PathMatch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.PathMatch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prefix", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_PathMatch {
    return new DocumentFilter_PathMatch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_PathMatch {
    return new DocumentFilter_PathMatch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_PathMatch {
    return new DocumentFilter_PathMatch().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_PathMatch | PlainMessage<DocumentFilter_PathMatch> | undefined, b: DocumentFilter_PathMatch | PlainMessage<DocumentFilter_PathMatch> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_PathMatch, a, b);
  }
}

/**
 * Matches documents an account contributed to.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.AuthorMatch
 */
export class DocumentFilter_AuthorMatch extends Message<DocumentFilter_AuthorMatch> {
  /**
   * Account principal to match. Matches when it is any one of the document's authors.
   *
   * @generated from field: string author = 1;
   */
  author = "";

  constructor(data?: PartialMessage<DocumentFilter_AuthorMatch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.AuthorMatch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "author", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_AuthorMatch {
    return new DocumentFilter_AuthorMatch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_AuthorMatch {
    return new DocumentFilter_AuthorMatch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_AuthorMatch {
    return new DocumentFilter_AuthorMatch().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_AuthorMatch | PlainMessage<DocumentFilter_AuthorMatch> | undefined, b: DocumentFilter_AuthorMatch | PlainMessage<DocumentFilter_AuthorMatch> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_AuthorMatch, a, b);
  }
}

/**
 * Matches documents whose built-in timestamp falls within a range.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentFilter.TimeRange
 */
export class DocumentFilter_TimeRange extends Message<DocumentFilter_TimeRange> {
  /**
   * Timestamp to filter on.
   *
   * @generated from field: com.seed.documents.v3alpha.DocumentFilter.TimeRange.Field field = 1;
   */
  field = DocumentFilter_TimeRange_Field.FIELD_UNSPECIFIED;

  /**
   * Optional. Inclusive lower bound. Unbounded when unset.
   * Rounded up to the next millisecond when finer precision is supplied.
   * Millisecond-aligned bounds are unchanged.
   *
   * @generated from field: google.protobuf.Timestamp start = 2;
   */
  start?: Timestamp;

  /**
   * Optional. Exclusive upper bound. Unbounded when unset.
   * Rounded up to the next millisecond when finer precision is supplied.
   * Millisecond-aligned bounds are unchanged.
   *
   * @generated from field: google.protobuf.Timestamp end = 3;
   */
  end?: Timestamp;

  constructor(data?: PartialMessage<DocumentFilter_TimeRange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentFilter.TimeRange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field", kind: "enum", T: proto3.getEnumType(DocumentFilter_TimeRange_Field) },
    { no: 2, name: "start", kind: "message", T: Timestamp },
    { no: 3, name: "end", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentFilter_TimeRange {
    return new DocumentFilter_TimeRange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentFilter_TimeRange {
    return new DocumentFilter_TimeRange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentFilter_TimeRange {
    return new DocumentFilter_TimeRange().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentFilter_TimeRange | PlainMessage<DocumentFilter_TimeRange> | undefined, b: DocumentFilter_TimeRange | PlainMessage<DocumentFilter_TimeRange> | undefined): boolean {
    return proto3.util.equals(DocumentFilter_TimeRange, a, b);
  }
}

/**
 * Built-in document timestamps that can be filtered on.
 *
 * @generated from enum com.seed.documents.v3alpha.DocumentFilter.TimeRange.Field
 */
export enum DocumentFilter_TimeRange_Field {
  /**
   * No field specified.
   *
   * @generated from enum value: FIELD_UNSPECIFIED = 0;
   */
  FIELD_UNSPECIFIED = 0,

  /**
   * When the document was first created.
   *
   * @generated from enum value: CREATE_TIME = 1;
   */
  CREATE_TIME = 1,

  /**
   * When the document was last changed.
   *
   * @generated from enum value: UPDATE_TIME = 2;
   */
  UPDATE_TIME = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(DocumentFilter_TimeRange_Field)
proto3.util.setEnumType(DocumentFilter_TimeRange_Field, "com.seed.documents.v3alpha.DocumentFilter.TimeRange.Field", [
  { no: 0, name: "FIELD_UNSPECIFIED" },
  { no: 1, name: "CREATE_TIME" },
  { no: 2, name: "UPDATE_TIME" },
]);

/**
 * Sorting configuration for QueryDocuments.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentSort
 */
export class DocumentSort extends Message<DocumentSort> {
  /**
   * User-defined attribute key to sort by. Mutually exclusive with `attribute`.
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * Whether to sort in descending order.
   *
   * @generated from field: bool descending = 2;
   */
  descending = false;

  /**
   * Built-in document field to sort by. Mutually exclusive with `key`.
   *
   * @generated from field: com.seed.documents.v3alpha.BuiltinSortAttribute attribute = 3;
   */
  attribute = BuiltinSortAttribute.UNSPECIFIED;

  constructor(data?: PartialMessage<DocumentSort>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentSort";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "descending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "attribute", kind: "enum", T: proto3.getEnumType(BuiltinSortAttribute) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentSort {
    return new DocumentSort().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentSort {
    return new DocumentSort().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentSort {
    return new DocumentSort().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentSort | PlainMessage<DocumentSort> | undefined, b: DocumentSort | PlainMessage<DocumentSort> | undefined): boolean {
    return proto3.util.equals(DocumentSort, a, b);
  }
}

/**
 * Request to query current non-deleted documents by attributes.
 *
 * @generated from message com.seed.documents.v3alpha.QueryDocumentsRequest
 */
export class QueryDocumentsRequest extends Message<QueryDocumentsRequest> {
  /**
   * Optional. Predicate documents must satisfy. When omitted, all visible documents match.
   *
   * @generated from field: com.seed.documents.v3alpha.DocumentFilter filter = 1;
   */
  filter?: DocumentFilter;

  /**
   * Optional. Attribute sort order, from highest to lowest priority.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentSort sort = 2;
   */
  sort: DocumentSort[] = [];

  /**
   * Optional. Number of results per page. Default is defined by the server.
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  /**
   * Optional. Value from next_page_token obtained from a previous response.
   *
   * @generated from field: string page_token = 4;
   */
  pageToken = "";

  constructor(data?: PartialMessage<QueryDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.QueryDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filter", kind: "message", T: DocumentFilter },
    { no: 2, name: "sort", kind: "message", T: DocumentSort, repeated: true },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QueryDocumentsRequest {
    return new QueryDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QueryDocumentsRequest {
    return new QueryDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QueryDocumentsRequest {
    return new QueryDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: QueryDocumentsRequest | PlainMessage<QueryDocumentsRequest> | undefined, b: QueryDocumentsRequest | PlainMessage<QueryDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(QueryDocumentsRequest, a, b);
  }
}

/**
 * Page of document attribute query results.
 *
 * @generated from message com.seed.documents.v3alpha.QueryDocumentsResponse
 */
export class QueryDocumentsResponse extends Message<QueryDocumentsResponse> {
  /**
   * Documents that matched the query.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentInfo documents = 1;
   */
  documents: DocumentInfo[] = [];

  /**
   * Token for the next page. Empty when there are no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<QueryDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.QueryDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: DocumentInfo, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QueryDocumentsResponse {
    return new QueryDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QueryDocumentsResponse {
    return new QueryDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QueryDocumentsResponse {
    return new QueryDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: QueryDocumentsResponse | PlainMessage<QueryDocumentsResponse> | undefined, b: QueryDocumentsResponse | PlainMessage<QueryDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(QueryDocumentsResponse, a, b);
  }
}

/**
 * One kind observed for an attribute name.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentAttributeKindUsage
 */
export class DocumentAttributeKindUsage extends Message<DocumentAttributeKindUsage> {
  /**
   * Observed attribute kind.
   *
   * @generated from field: com.seed.documents.v3alpha.DocumentAttributeKind kind = 1;
   */
  kind = DocumentAttributeKind.UNSPECIFIED;

  constructor(data?: PartialMessage<DocumentAttributeKindUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentAttributeKindUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(DocumentAttributeKind) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentAttributeKindUsage {
    return new DocumentAttributeKindUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentAttributeKindUsage {
    return new DocumentAttributeKindUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentAttributeKindUsage {
    return new DocumentAttributeKindUsage().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentAttributeKindUsage | PlainMessage<DocumentAttributeKindUsage> | undefined, b: DocumentAttributeKindUsage | PlainMessage<DocumentAttributeKindUsage> | undefined): boolean {
    return proto3.util.equals(DocumentAttributeKindUsage, a, b);
  }
}

/**
 * Request for user-defined attribute name autocomplete.
 *
 * @generated from message com.seed.documents.v3alpha.ListDocumentAttributeNamesRequest
 */
export class ListDocumentAttributeNamesRequest extends Message<ListDocumentAttributeNamesRequest> {
  /**
   * Optional. Account whose attribute names should be prioritized. When
   * omitted, suggestions are ordered globally.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Optional. Parent object path. Results are direct children of this path.
   *
   * @generated from field: repeated string parent_path = 2;
   */
  parentPath: string[] = [];

  /**
   * Optional. Case-insensitive name prefix.
   *
   * @generated from field: string prefix = 3;
   */
  prefix = "";

  /**
   * Optional. Number of results per page.
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize = 0;

  /**
   * Optional. Value from next_page_token obtained from a previous response.
   *
   * @generated from field: string page_token = 5;
   */
  pageToken = "";

  /**
   * Optional. Return complete scalar paths instead of direct children. Intended
   * for global query builders rather than hierarchical attribute editors.
   *
   * @generated from field: bool recursive = 6;
   */
  recursive = false;

  constructor(data?: PartialMessage<ListDocumentAttributeNamesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDocumentAttributeNamesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parent_path", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "recursive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentAttributeNamesRequest {
    return new ListDocumentAttributeNamesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentAttributeNamesRequest {
    return new ListDocumentAttributeNamesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentAttributeNamesRequest {
    return new ListDocumentAttributeNamesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentAttributeNamesRequest | PlainMessage<ListDocumentAttributeNamesRequest> | undefined, b: ListDocumentAttributeNamesRequest | PlainMessage<ListDocumentAttributeNamesRequest> | undefined): boolean {
    return proto3.util.equals(ListDocumentAttributeNamesRequest, a, b);
  }
}

/**
 * A user-defined attribute name suggestion.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentAttributeName
 */
export class DocumentAttributeName extends Message<DocumentAttributeName> {
  /**
   * Direct child name relative to the requested parent path, or a complete
   * scalar path when recursive was requested.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Kinds observed at this path, including object when child paths exist. For
   * a prioritized account, these come from that account when possible.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentAttributeKindUsage kinds = 2;
   */
  kinds: DocumentAttributeKindUsage[] = [];

  constructor(data?: PartialMessage<DocumentAttributeName>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentAttributeName";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kinds", kind: "message", T: DocumentAttributeKindUsage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentAttributeName {
    return new DocumentAttributeName().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentAttributeName {
    return new DocumentAttributeName().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentAttributeName {
    return new DocumentAttributeName().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentAttributeName | PlainMessage<DocumentAttributeName> | undefined, b: DocumentAttributeName | PlainMessage<DocumentAttributeName> | undefined): boolean {
    return proto3.util.equals(DocumentAttributeName, a, b);
  }
}

/**
 * Page of user-defined attribute name suggestions.
 *
 * @generated from message com.seed.documents.v3alpha.ListDocumentAttributeNamesResponse
 */
export class ListDocumentAttributeNamesResponse extends Message<ListDocumentAttributeNamesResponse> {
  /**
   * Matching direct child attribute names.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentAttributeName names = 1;
   */
  names: DocumentAttributeName[] = [];

  /**
   * Token for the next page. Empty when there are no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListDocumentAttributeNamesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDocumentAttributeNamesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "names", kind: "message", T: DocumentAttributeName, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentAttributeNamesResponse {
    return new ListDocumentAttributeNamesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentAttributeNamesResponse {
    return new ListDocumentAttributeNamesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentAttributeNamesResponse {
    return new ListDocumentAttributeNamesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentAttributeNamesResponse | PlainMessage<ListDocumentAttributeNamesResponse> | undefined, b: ListDocumentAttributeNamesResponse | PlainMessage<ListDocumentAttributeNamesResponse> | undefined): boolean {
    return proto3.util.equals(ListDocumentAttributeNamesResponse, a, b);
  }
}

/**
 * Request for user-defined attribute value autocomplete.
 *
 * @generated from message com.seed.documents.v3alpha.ListDocumentAttributeValuesRequest
 */
export class ListDocumentAttributeValuesRequest extends Message<ListDocumentAttributeValuesRequest> {
  /**
   * Required. Exact nested path of the user-defined attribute.
   *
   * @generated from field: repeated string path = 1;
   */
  path: string[] = [];

  /**
   * Required. Scalar kind whose values should be returned.
   *
   * @generated from field: com.seed.documents.v3alpha.DocumentAttributeKind kind = 2;
   */
  kind = DocumentAttributeKind.UNSPECIFIED;

  /**
   * Optional. Account whose values should be searched. When omitted, values
   * are searched globally.
   *
   * @generated from field: string account = 3;
   */
  account = "";

  /**
   * Optional. Case-insensitive prefix of the value's display representation.
   *
   * @generated from field: string prefix = 4;
   */
  prefix = "";

  /**
   * Optional. Number of results per page.
   *
   * @generated from field: int32 page_size = 5;
   */
  pageSize = 0;

  /**
   * Optional. Value from next_page_token obtained from a previous response.
   *
   * @generated from field: string page_token = 6;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListDocumentAttributeValuesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDocumentAttributeValuesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(DocumentAttributeKind) },
    { no: 3, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentAttributeValuesRequest {
    return new ListDocumentAttributeValuesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentAttributeValuesRequest {
    return new ListDocumentAttributeValuesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentAttributeValuesRequest {
    return new ListDocumentAttributeValuesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentAttributeValuesRequest | PlainMessage<ListDocumentAttributeValuesRequest> | undefined, b: ListDocumentAttributeValuesRequest | PlainMessage<ListDocumentAttributeValuesRequest> | undefined): boolean {
    return proto3.util.equals(ListDocumentAttributeValuesRequest, a, b);
  }
}

/**
 * A known typed value for a user-defined document attribute.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentAttributeValue
 */
export class DocumentAttributeValue extends Message<DocumentAttributeValue> {
  /**
   * Typed scalar value.
   *
   * @generated from field: com.seed.documents.v3alpha.AttributeValue value = 1;
   */
  value?: AttributeValue;

  constructor(data?: PartialMessage<DocumentAttributeValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentAttributeValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "message", T: AttributeValue },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentAttributeValue {
    return new DocumentAttributeValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentAttributeValue {
    return new DocumentAttributeValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentAttributeValue {
    return new DocumentAttributeValue().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentAttributeValue | PlainMessage<DocumentAttributeValue> | undefined, b: DocumentAttributeValue | PlainMessage<DocumentAttributeValue> | undefined): boolean {
    return proto3.util.equals(DocumentAttributeValue, a, b);
  }
}

/**
 * Page of known values for a user-defined document attribute.
 *
 * @generated from message com.seed.documents.v3alpha.ListDocumentAttributeValuesResponse
 */
export class ListDocumentAttributeValuesResponse extends Message<ListDocumentAttributeValuesResponse> {
  /**
   * Matching typed values.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentAttributeValue values = 1;
   */
  values: DocumentAttributeValue[] = [];

  /**
   * Token for the next page. Empty when there are no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListDocumentAttributeValuesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDocumentAttributeValuesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "message", T: DocumentAttributeValue, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentAttributeValuesResponse {
    return new ListDocumentAttributeValuesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentAttributeValuesResponse {
    return new ListDocumentAttributeValuesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentAttributeValuesResponse {
    return new ListDocumentAttributeValuesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentAttributeValuesResponse | PlainMessage<ListDocumentAttributeValuesResponse> | undefined, b: ListDocumentAttributeValuesResponse | PlainMessage<ListDocumentAttributeValuesResponse> | undefined): boolean {
    return proto3.util.equals(ListDocumentAttributeValuesResponse, a, b);
  }
}

/**
 * Request for listing document changes.
 *
 * @generated from message com.seed.documents.v3alpha.ListDocumentChangesRequest
 */
export class ListDocumentChangesRequest extends Message<ListDocumentChangesRequest> {
  /**
   * Required. ID of the account to list versions for.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path of the document to list versions for.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Required. Version of the document to list changes for.
   *
   * @generated from field: string version = 3;
   */
  version = "";

  /**
   * Optional. Number of results per page. Default is defined by the server.
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize = 0;

  /**
   * Optional. Value from next_page_token obtained from a previous response.
   *
   * @generated from field: string page_token = 5;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListDocumentChangesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDocumentChangesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentChangesRequest {
    return new ListDocumentChangesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentChangesRequest {
    return new ListDocumentChangesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentChangesRequest {
    return new ListDocumentChangesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentChangesRequest | PlainMessage<ListDocumentChangesRequest> | undefined, b: ListDocumentChangesRequest | PlainMessage<ListDocumentChangesRequest> | undefined): boolean {
    return proto3.util.equals(ListDocumentChangesRequest, a, b);
  }
}

/**
 * Response with list of document versions.
 *
 * @generated from message com.seed.documents.v3alpha.ListDocumentChangesResponse
 */
export class ListDocumentChangesResponse extends Message<ListDocumentChangesResponse> {
  /**
   * List of document versions.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.DocumentChangeInfo changes = 1;
   */
  changes: DocumentChangeInfo[] = [];

  /**
   * Token for the next page if there're more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListDocumentChangesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListDocumentChangesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "changes", kind: "message", T: DocumentChangeInfo, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentChangesResponse {
    return new ListDocumentChangesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentChangesResponse {
    return new ListDocumentChangesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentChangesResponse {
    return new ListDocumentChangesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentChangesResponse | PlainMessage<ListDocumentChangesResponse> | undefined, b: ListDocumentChangesResponse | PlainMessage<ListDocumentChangesResponse> | undefined): boolean {
    return proto3.util.equals(ListDocumentChangesResponse, a, b);
  }
}

/**
 * Request to get a specific document change.
 *
 * @generated from message com.seed.documents.v3alpha.GetDocumentChangeRequest
 */
export class GetDocumentChangeRequest extends Message<GetDocumentChangeRequest> {
  /**
   * Required. ID of the change to retrieve.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetDocumentChangeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetDocumentChangeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDocumentChangeRequest {
    return new GetDocumentChangeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDocumentChangeRequest {
    return new GetDocumentChangeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDocumentChangeRequest {
    return new GetDocumentChangeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDocumentChangeRequest | PlainMessage<GetDocumentChangeRequest> | undefined, b: GetDocumentChangeRequest | PlainMessage<GetDocumentChangeRequest> | undefined): boolean {
    return proto3.util.equals(GetDocumentChangeRequest, a, b);
  }
}

/**
 * Request to update document's read status.
 *
 * @generated from message com.seed.documents.v3alpha.UpdateDocumentReadStatusRequest
 */
export class UpdateDocumentReadStatusRequest extends Message<UpdateDocumentReadStatusRequest> {
  /**
   * Required. ID of the account to update the document in.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path of the document to update.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Required. New read status of the document.
   *
   * @generated from field: bool is_read = 3;
   */
  isRead = false;

  /**
   * Optional. Whether the status should be updated recursively for children of the path.
   *
   * @generated from field: bool is_recursive = 4;
   */
  isRecursive = false;

  constructor(data?: PartialMessage<UpdateDocumentReadStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.UpdateDocumentReadStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_read", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_recursive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDocumentReadStatusRequest {
    return new UpdateDocumentReadStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDocumentReadStatusRequest {
    return new UpdateDocumentReadStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDocumentReadStatusRequest {
    return new UpdateDocumentReadStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDocumentReadStatusRequest | PlainMessage<UpdateDocumentReadStatusRequest> | undefined, b: UpdateDocumentReadStatusRequest | PlainMessage<UpdateDocumentReadStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateDocumentReadStatusRequest, a, b);
  }
}

/**
 * Request to create a Ref.
 *
 * @generated from message com.seed.documents.v3alpha.CreateRefRequest
 */
export class CreateRefRequest extends Message<CreateRefRequest> {
  /**
   * Required. The ID of the account/space in which to create the Ref.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path of the new Ref.
   * Empty string means root document.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Required. Target for the new Ref.
   *
   * @generated from field: com.seed.documents.v3alpha.RefTarget target = 3;
   */
  target?: RefTarget;

  /**
   * Required. Name of the signing key to use for signing the Ref.
   *
   * @generated from field: string signing_key_name = 4;
   */
  signingKeyName = "";

  /**
   * Optional. ID of the Capability blob that grants the necessary rights to the signin key
   * to write Refs for the requested account + path.
   *
   * @generated from field: string capability = 5;
   */
  capability = "";

  /**
   * Optional. A timestamp of the Ref blob.
   * If not specified the server will use the current time.
   * The provided timestamp will be rounded to the nearest millisecond,
   * so the final timestamp in the resulting Ref blob may not be exactly as provided.
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 6;
   */
  timestamp?: Timestamp;

  /**
   * Optional. The generation number for the Ref.
   * If not specified, the server will use the generation number of the most recent generation,
   * or will create a fresh generation number if there are no existing Refs for this path.
   *
   * @generated from field: int64 generation = 7;
   */
  generation = protoInt64.zero;

  /**
   * Output only. Visibility of the document.
   *
   * @generated from field: com.seed.documents.v3alpha.ResourceVisibility visibility = 8;
   */
  visibility = ResourceVisibility.UNSPECIFIED;

  constructor(data?: PartialMessage<CreateRefRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.CreateRefRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target", kind: "message", T: RefTarget },
    { no: 4, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "capability", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "timestamp", kind: "message", T: Timestamp },
    { no: 7, name: "generation", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "visibility", kind: "enum", T: proto3.getEnumType(ResourceVisibility) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRefRequest {
    return new CreateRefRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRefRequest {
    return new CreateRefRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRefRequest {
    return new CreateRefRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRefRequest | PlainMessage<CreateRefRequest> | undefined, b: CreateRefRequest | PlainMessage<CreateRefRequest> | undefined): boolean {
    return proto3.util.equals(CreateRefRequest, a, b);
  }
}

/**
 * Request to get a Ref by ID.
 *
 * @generated from message com.seed.documents.v3alpha.GetRefRequest
 */
export class GetRefRequest extends Message<GetRefRequest> {
  /**
   * Required. ID of the Ref blob to retrieve.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetRefRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetRefRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRefRequest {
    return new GetRefRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRefRequest {
    return new GetRefRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRefRequest {
    return new GetRefRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRefRequest | PlainMessage<GetRefRequest> | undefined, b: GetRefRequest | PlainMessage<GetRefRequest> | undefined): boolean {
    return proto3.util.equals(GetRefRequest, a, b);
  }
}

/**
 * Request to list Refs for a document.
 *
 * @generated from message com.seed.documents.v3alpha.ListRefsRequest
 */
export class ListRefsRequest extends Message<ListRefsRequest> {
  /**
   * Required. Account ID where the document is located.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path of the document.
   * Empty string means root document.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Optional. Number of items to return per page.
   * Pagination parameters are currently accepted but ignored.
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  /**
   * Optional. Token from a previous ListRefsResponse.next_page_token.
   * Pagination parameters are currently accepted but ignored.
   *
   * @generated from field: string page_token = 4;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListRefsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListRefsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRefsRequest {
    return new ListRefsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRefsRequest {
    return new ListRefsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRefsRequest {
    return new ListRefsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRefsRequest | PlainMessage<ListRefsRequest> | undefined, b: ListRefsRequest | PlainMessage<ListRefsRequest> | undefined): boolean {
    return proto3.util.equals(ListRefsRequest, a, b);
  }
}

/**
 * Response to list Refs for a document.
 *
 * @generated from message com.seed.documents.v3alpha.ListRefsResponse
 */
export class ListRefsResponse extends Message<ListRefsResponse> {
  /**
   * Refs for the requested document.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.Ref refs = 1;
   */
  refs: Ref[] = [];

  /**
   * Optional. Token for fetching the next page.
   * Empty while pagination is not implemented.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListRefsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListRefsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "refs", kind: "message", T: Ref, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRefsResponse {
    return new ListRefsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRefsResponse {
    return new ListRefsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRefsResponse {
    return new ListRefsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRefsResponse | PlainMessage<ListRefsResponse> | undefined, b: ListRefsResponse | PlainMessage<ListRefsResponse> | undefined): boolean {
    return proto3.util.equals(ListRefsResponse, a, b);
  }
}

/**
 * Information about a particular document version.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentChangeInfo
 */
export class DocumentChangeInfo extends Message<DocumentChangeInfo> {
  /**
   * CID of the change.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Author of the change.
   *
   * @generated from field: string author = 2;
   */
  author = "";

  /**
   * List of change IDs that this change depends on.
   *
   * @generated from field: repeated string deps = 3;
   */
  deps: string[] = [];

  /**
   * Time when the change was created (as claimed by the author).
   *
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  constructor(data?: PartialMessage<DocumentChangeInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentChangeInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "author", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "deps", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "create_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentChangeInfo {
    return new DocumentChangeInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentChangeInfo {
    return new DocumentChangeInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentChangeInfo {
    return new DocumentChangeInfo().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentChangeInfo | PlainMessage<DocumentChangeInfo> | undefined, b: DocumentChangeInfo | PlainMessage<DocumentChangeInfo> | undefined): boolean {
    return proto3.util.equals(DocumentChangeInfo, a, b);
  }
}

/**
 * Basic data about a document with some aggregations and metadata.
 * It's like Document, without the content, but with some additional info.
 * Type derived from a document's published content.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentInfo
 */
export class DocumentInfo extends Message<DocumentInfo> {
  /**
   * Account to which the document belongs.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Path of the document within the account.
   * Empty string means root document.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * User-defined metadata attributes of the document.
   *
   * @generated from field: google.protobuf.Struct metadata = 3;
   */
  metadata?: Struct;

  /**
   * Every author ID who has ever made changes to this document.
   *
   * @generated from field: repeated string authors = 4;
   */
  authors: string[] = [];

  /**
   * Time when the document was created.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: Timestamp;

  /**
   * Time when the document was updated.
   * I.e. timestamp of the most recent change.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 6;
   */
  updateTime?: Timestamp;

  /**
   * ID of the genesis change of this document.
   *
   * @generated from field: string genesis = 8;
   */
  genesis = "";

  /**
   * Current version of the document.
   *
   * @generated from field: string version = 9;
   */
  version = "";

  /**
   * Breadcrumbs of this document.
   * The number of items in this list corresponds to the number of segments
   * in the path of the document minus 1 (the document itself).
   *
   * E.g. for a document "/cars/jp/honda" there will be 2 breadcrumbs: "cars" and "jp".
   *
   * If we don't have a document for some of the path segements for whatever reason,
   * the corresponding breadcrumb segment will be null.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.Breadcrumb breadcrumbs = 10;
   */
  breadcrumbs: Breadcrumb[] = [];

  /**
   * Summary of the activity on the document.
   *
   * @generated from field: com.seed.documents.v3alpha.ActivitySummary activity_summary = 11;
   */
  activitySummary?: ActivitySummary;

  /**
   * Information about the generation of the document.
   *
   * @generated from field: com.seed.documents.v3alpha.GenerationInfo generation_info = 12;
   */
  generationInfo?: GenerationInfo;

  /**
   * Output only. Redirect information if the document is a republish or a redirect.
   *
   * @generated from field: com.seed.documents.v3alpha.RefTarget.Redirect redirect_info = 13;
   */
  redirectInfo?: RefTarget_Redirect;

  /**
   * Output only. Visibility of the document.
   *
   * @generated from field: com.seed.documents.v3alpha.ResourceVisibility visibility = 14;
   */
  visibility = ResourceVisibility.UNSPECIFIED;

  /**
   * Output only. Link of the first image block in the document's content
   * (in reading order), derived by the indexer for documents that have no
   * explicit cover or icon. Clients use it as a fallback cover on directory
   * cards without fetching the full document.
   *
   * Unset means the indexer hasn't derived it (yet); an empty string means
   * the document is known to have no content image.
   *
   * @generated from field: optional string first_image_in_content = 15;
   */
  firstImageInContent?: string;

  /**
   * Output only. Whether the published document has the Collection shape. Derived
   * by the indexer and backfilled incrementally for existing documents.
   * Unset means the indexer has not derived the value yet.
   *
   * @generated from field: optional bool is_collection = 16;
   */
  isCollection?: boolean;

  constructor(data?: PartialMessage<DocumentInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "metadata", kind: "message", T: Struct },
    { no: 4, name: "authors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "create_time", kind: "message", T: Timestamp },
    { no: 6, name: "update_time", kind: "message", T: Timestamp },
    { no: 8, name: "genesis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "breadcrumbs", kind: "message", T: Breadcrumb, repeated: true },
    { no: 11, name: "activity_summary", kind: "message", T: ActivitySummary },
    { no: 12, name: "generation_info", kind: "message", T: GenerationInfo },
    { no: 13, name: "redirect_info", kind: "message", T: RefTarget_Redirect },
    { no: 14, name: "visibility", kind: "enum", T: proto3.getEnumType(ResourceVisibility) },
    { no: 15, name: "first_image_in_content", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "is_collection", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentInfo {
    return new DocumentInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentInfo {
    return new DocumentInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentInfo {
    return new DocumentInfo().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentInfo | PlainMessage<DocumentInfo> | undefined, b: DocumentInfo | PlainMessage<DocumentInfo> | undefined): boolean {
    return proto3.util.equals(DocumentInfo, a, b);
  }
}

/**
 * Information about the generation of a document.
 *
 * @generated from message com.seed.documents.v3alpha.GenerationInfo
 */
export class GenerationInfo extends Message<GenerationInfo> {
  /**
   * CID of the genesis change.
   *
   * @generated from field: string genesis = 1;
   */
  genesis = "";

  /**
   * A generation number of the document.
   * Usually it's a timestamp of the first time the generation is created,
   * but it shouldn't be used as such, and should instead be treated as an opaque value.
   *
   * @generated from field: int64 generation = 2;
   */
  generation = protoInt64.zero;

  constructor(data?: PartialMessage<GenerationInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GenerationInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "genesis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "generation", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerationInfo {
    return new GenerationInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerationInfo {
    return new GenerationInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerationInfo {
    return new GenerationInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GenerationInfo | PlainMessage<GenerationInfo> | undefined, b: GenerationInfo | PlainMessage<GenerationInfo> | undefined): boolean {
    return proto3.util.equals(GenerationInfo, a, b);
  }
}

/**
 * Summary of the activity on a document or account.
 *
 * @generated from message com.seed.documents.v3alpha.ActivitySummary
 */
export class ActivitySummary extends Message<ActivitySummary> {
  /**
   * Timestamp of the most recent comment.
   *
   * @generated from field: google.protobuf.Timestamp latest_comment_time = 1;
   */
  latestCommentTime?: Timestamp;

  /**
   * ID of the most recent comment.
   *
   * @generated from field: string latest_comment_id = 4;
   */
  latestCommentId = "";

  /**
   * Total number of comments.
   *
   * @generated from field: int32 comment_count = 2;
   */
  commentCount = 0;

  /**
   * Timestamp of the most recent change.
   *
   * @generated from field: google.protobuf.Timestamp latest_change_time = 3;
   */
  latestChangeTime?: Timestamp;

  /**
   * Whether there's any unread activity on this document/account.
   *
   * @generated from field: bool is_unread = 5;
   */
  isUnread = false;

  /**
   * Output only. Number of alive direct child documents.
   * Only populated in document listings; listing cards show it without
   * fetching a per-document interaction summary.
   *
   * @generated from field: int32 children_count = 6;
   */
  childrenCount = 0;

  constructor(data?: PartialMessage<ActivitySummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ActivitySummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "latest_comment_time", kind: "message", T: Timestamp },
    { no: 4, name: "latest_comment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "comment_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "latest_change_time", kind: "message", T: Timestamp },
    { no: 5, name: "is_unread", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "children_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivitySummary {
    return new ActivitySummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivitySummary {
    return new ActivitySummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivitySummary {
    return new ActivitySummary().fromJsonString(jsonString, options);
  }

  static equals(a: ActivitySummary | PlainMessage<ActivitySummary> | undefined, b: ActivitySummary | PlainMessage<ActivitySummary> | undefined): boolean {
    return proto3.util.equals(ActivitySummary, a, b);
  }
}

/**
 * Basic information about ancestor documents in the path hierarchy.
 *
 * @generated from message com.seed.documents.v3alpha.Breadcrumb
 */
export class Breadcrumb extends Message<Breadcrumb> {
  /**
   * Title of the document.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Path of the document.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Will be true if we don't have any indexed information about this document.
   *
   * @generated from field: bool is_missing = 3;
   */
  isMissing = false;

  constructor(data?: PartialMessage<Breadcrumb>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Breadcrumb";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Breadcrumb {
    return new Breadcrumb().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Breadcrumb {
    return new Breadcrumb().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Breadcrumb {
    return new Breadcrumb().fromJsonString(jsonString, options);
  }

  static equals(a: Breadcrumb | PlainMessage<Breadcrumb> | undefined, b: Breadcrumb | PlainMessage<Breadcrumb> | undefined): boolean {
    return proto3.util.equals(Breadcrumb, a, b);
  }
}

/**
 * Document represents metadata and content of a document.
 *
 * @generated from message com.seed.documents.v3alpha.Document
 */
export class Document extends Message<Document> {
  /**
   * Account to which the document belongs.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Path of the document within the account.
   * Empty string means root document.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Metadata values for a document.
   *
   * @generated from field: google.protobuf.Struct metadata = 3;
   */
  metadata?: Struct;

  /**
   * Output only. Every account ID who has modified the document.
   * Includes the original author as well.
   *
   * @generated from field: repeated string authors = 5;
   */
  authors: string[] = [];

  /**
   * Blocks content of the document.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.BlockNode content = 6;
   */
  content: BlockNode[] = [];

  /**
   * Output only. Blocks that were created but not moved into the document content.
   *
   * @generated from field: map<string, com.seed.documents.v3alpha.BlockNode> detached_blocks = 14;
   */
  detachedBlocks: { [key: string]: BlockNode } = {};

  /**
   * Output only. Time when document was created.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 7;
   */
  createTime?: Timestamp;

  /**
   * Output only. Time when document was updated.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 8;
   */
  updateTime?: Timestamp;

  /**
   * Output only. ID of the genesis change of this document.
   *
   * @generated from field: string genesis = 9;
   */
  genesis = "";

  /**
   * Output only. Current version of the document.
   *
   * @generated from field: string version = 10;
   */
  version = "";

  /**
   * Output only. Information about the generation of the document.
   *
   * @generated from field: com.seed.documents.v3alpha.GenerationInfo generation_info = 13;
   */
  generationInfo?: GenerationInfo;

  /**
   * Output only. Visibility of the document.
   *
   * @generated from field: com.seed.documents.v3alpha.ResourceVisibility visibility = 15;
   */
  visibility = ResourceVisibility.UNSPECIFIED;

  constructor(data?: PartialMessage<Document>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Document";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "metadata", kind: "message", T: Struct },
    { no: 5, name: "authors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "content", kind: "message", T: BlockNode, repeated: true },
    { no: 14, name: "detached_blocks", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: BlockNode} },
    { no: 7, name: "create_time", kind: "message", T: Timestamp },
    { no: 8, name: "update_time", kind: "message", T: Timestamp },
    { no: 9, name: "genesis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "generation_info", kind: "message", T: GenerationInfo },
    { no: 15, name: "visibility", kind: "enum", T: proto3.getEnumType(ResourceVisibility) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Document {
    return new Document().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Document {
    return new Document().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Document {
    return new Document().fromJsonString(jsonString, options);
  }

  static equals(a: Document | PlainMessage<Document> | undefined, b: Document | PlainMessage<Document> | undefined): boolean {
    return proto3.util.equals(Document, a, b);
  }
}

/**
 * Content block with children.
 *
 * @generated from message com.seed.documents.v3alpha.BlockNode
 */
export class BlockNode extends Message<BlockNode> {
  /**
   * Content block.
   *
   * @generated from field: com.seed.documents.v3alpha.Block block = 1;
   */
  block?: Block;

  /**
   * Child blocks.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.BlockNode children = 2;
   */
  children: BlockNode[] = [];

  constructor(data?: PartialMessage<BlockNode>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.BlockNode";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "block", kind: "message", T: Block },
    { no: 2, name: "children", kind: "message", T: BlockNode, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockNode {
    return new BlockNode().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockNode {
    return new BlockNode().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockNode {
    return new BlockNode().fromJsonString(jsonString, options);
  }

  static equals(a: BlockNode | PlainMessage<BlockNode> | undefined, b: BlockNode | PlainMessage<BlockNode> | undefined): boolean {
    return proto3.util.equals(BlockNode, a, b);
  }
}

/**
 * Content block.
 *
 * @generated from message com.seed.documents.v3alpha.Block
 */
export class Block extends Message<Block> {
  /**
   * Block ID. Must be unique within the document.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Type of the block. Specific to the renderer.
   *
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * Text of the content block.
   *
   * @generated from field: string text = 3;
   */
  text = "";

  /**
   * Optional. The hyperlink to an external resource.
   * Must be a valid URL.
   *
   * @generated from field: string link = 7;
   */
  link = "";

  /**
   * Remaining type-specific attribtues of the block.
   * Logically, these attributes are on the same level as the other fields,
   * i.e. the field `attributes` should not exist,
   * but because protobuf doesn't support arbitrary fields, and we don't want/need
   * to specify the types of all the possible fields, we use this approach of storing
   * the rest of the fields in this open-ended attributes map.
   * The side-effect of this is that `attributes` map must not have any keys
   * that conflict with the names of the top-level fields.
   *
   * @generated from field: google.protobuf.Struct attributes = 4;
   */
  attributes?: Struct;

  /**
   * Annotation "layers" of the block.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.Annotation annotations = 5;
   */
  annotations: Annotation[] = [];

  /**
   * Output only. Current revision of the block. It's the ID of the last Change that modified this block.
   * Additional information about the Change can be obtained using the Changes service.
   *
   * @generated from field: string revision = 6;
   */
  revision = "";

  constructor(data?: PartialMessage<Block>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Block";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attributes", kind: "message", T: Struct },
    { no: 5, name: "annotations", kind: "message", T: Annotation, repeated: true },
    { no: 6, name: "revision", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Block {
    return new Block().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Block {
    return new Block().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Block {
    return new Block().fromJsonString(jsonString, options);
  }

  static equals(a: Block | PlainMessage<Block> | undefined, b: Block | PlainMessage<Block> | undefined): boolean {
    return proto3.util.equals(Block, a, b);
  }
}

/**
 * Conceptual annotation "layer" that is applied to arbitrary spans of block text.
 * An "identity" of the layer should be derived deterministically based on its type
 * attributes. Spans inside the same annotation can't overlap.
 *
 * Spans are stored inside the Annotation in a "columnar" format,
 * i.e. StructureOfArrays instead of ArrayOfStructures. See: https://en.wikipedia.org/wiki/AoS_and_SoA.
 * This is useful to reduce the number of allocations and offers more compact serialization, because
 * protobuf is able to "pack" primitive repeated fields more efficiently.
 *
 * @generated from message com.seed.documents.v3alpha.Annotation
 */
export class Annotation extends Message<Annotation> {
  /**
   * Type of the annotation.
   *
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * Optional. A hyperlink to an external resource.
   * Must be a valid URL.
   *
   * @generated from field: string link = 5;
   */
  link = "";

  /**
   * Arbitrary key-value attributes of the annotation.
   *
   * @generated from field: google.protobuf.Struct attributes = 2;
   */
  attributes?: Struct;

  /**
   * Start offsets of possibly disjoint spans of text for which this annotation is applied.
   * Must be sorted and have the same number of items as `ends` list.
   *
   * @generated from field: repeated int32 starts = 3;
   */
  starts: number[] = [];

  /**
   * End offsets of possibly disjoint spans of text for which this annotation is applied.
   * Must be sorted and have the same number of items as `starts` list.
   *
   * @generated from field: repeated int32 ends = 4;
   */
  ends: number[] = [];

  constructor(data?: PartialMessage<Annotation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Annotation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attributes", kind: "message", T: Struct },
    { no: 3, name: "starts", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "ends", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Annotation {
    return new Annotation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Annotation {
    return new Annotation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Annotation {
    return new Annotation().fromJsonString(jsonString, options);
  }

  static equals(a: Annotation | PlainMessage<Annotation> | undefined, b: Annotation | PlainMessage<Annotation> | undefined): boolean {
    return proto3.util.equals(Annotation, a, b);
  }
}

/**
 * Granular document change.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentChange
 */
export class DocumentChange extends Message<DocumentChange> {
  /**
   * @generated from oneof com.seed.documents.v3alpha.DocumentChange.op
   */
  op: {
    /**
     * New metadata to set on the document.
     *
     * Deprecated: Use SetAttribute instead.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentChange.SetMetadata set_metadata = 1;
     */
    value: DocumentChange_SetMetadata;
    case: "setMetadata";
  } | {
    /**
     * Move operation that creates/moves a block within the document hierarchy.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentChange.MoveBlock move_block = 2;
     */
    value: DocumentChange_MoveBlock;
    case: "moveBlock";
  } | {
    /**
     * New block state that replaces an existing block.
     *
     * @generated from field: com.seed.documents.v3alpha.Block replace_block = 3;
     */
    value: Block;
    case: "replaceBlock";
  } | {
    /**
     * ID of a block to delete.
     *
     * @generated from field: string delete_block = 4;
     */
    value: string;
    case: "deleteBlock";
  } | {
    /**
     * Sets an attribute on a block.
     *
     * @generated from field: com.seed.documents.v3alpha.DocumentChange.SetAttribute set_attribute = 5;
     */
    value: DocumentChange_SetAttribute;
    case: "setAttribute";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<DocumentChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "set_metadata", kind: "message", T: DocumentChange_SetMetadata, oneof: "op" },
    { no: 2, name: "move_block", kind: "message", T: DocumentChange_MoveBlock, oneof: "op" },
    { no: 3, name: "replace_block", kind: "message", T: Block, oneof: "op" },
    { no: 4, name: "delete_block", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "op" },
    { no: 5, name: "set_attribute", kind: "message", T: DocumentChange_SetAttribute, oneof: "op" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentChange {
    return new DocumentChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentChange {
    return new DocumentChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentChange {
    return new DocumentChange().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentChange | PlainMessage<DocumentChange> | undefined, b: DocumentChange | PlainMessage<DocumentChange> | undefined): boolean {
    return proto3.util.equals(DocumentChange, a, b);
  }
}

/**
 * Operation to move an existing block to a different place in the document.
 * Move and Create operations are both expressed with this.
 * Conceptually new blocks are moved out of nowhere into the document.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentChange.MoveBlock
 */
export class DocumentChange_MoveBlock extends Message<DocumentChange_MoveBlock> {
  /**
   * ID of the block to move.
   *
   * @generated from field: string block_id = 1;
   */
  blockId = "";

  /**
   * ID of the new parent for the block being moved.
   *
   * @generated from field: string parent = 2;
   */
  parent = "";

  /**
   * ID of the new left sibling for the block being moved.
   *
   * @generated from field: string left_sibling = 3;
   */
  leftSibling = "";

  constructor(data?: PartialMessage<DocumentChange_MoveBlock>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentChange.MoveBlock";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "block_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "left_sibling", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentChange_MoveBlock {
    return new DocumentChange_MoveBlock().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentChange_MoveBlock {
    return new DocumentChange_MoveBlock().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentChange_MoveBlock {
    return new DocumentChange_MoveBlock().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentChange_MoveBlock | PlainMessage<DocumentChange_MoveBlock> | undefined, b: DocumentChange_MoveBlock | PlainMessage<DocumentChange_MoveBlock> | undefined): boolean {
    return proto3.util.equals(DocumentChange_MoveBlock, a, b);
  }
}

/**
 * Operation to replace a metadata field with a new value.
 * This is an old operation, and you should use [SetAttribute] instead for greater flexibility.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentChange.SetMetadata
 */
export class DocumentChange_SetMetadata extends Message<DocumentChange_SetMetadata> {
  /**
   * Metadata key to set.
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * Metadata value to set.
   *
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<DocumentChange_SetMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentChange.SetMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentChange_SetMetadata {
    return new DocumentChange_SetMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentChange_SetMetadata {
    return new DocumentChange_SetMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentChange_SetMetadata {
    return new DocumentChange_SetMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentChange_SetMetadata | PlainMessage<DocumentChange_SetMetadata> | undefined, b: DocumentChange_SetMetadata | PlainMessage<DocumentChange_SetMetadata> | undefined): boolean {
    return proto3.util.equals(DocumentChange_SetMetadata, a, b);
  }
}

/**
 * Operation to set an attribute of a block or document.
 *
 * @generated from message com.seed.documents.v3alpha.DocumentChange.SetAttribute
 */
export class DocumentChange_SetAttribute extends Message<DocumentChange_SetAttribute> {
  /**
   * ID of the block to set the attribute on.
   *
   * Empty string means the document itself.
   * Special strings "footer" and "header" can be used to set attributes on the document footer and header blocks.
   *
   * @generated from field: string block_id = 1;
   */
  blockId = "";

  /**
   * A path of keys to set the value for.
   * It's a list to support nested attributes.
   *
   * @generated from field: repeated string key = 2;
   */
  key: string[] = [];

  /**
   * Value to set.
   *
   * @generated from oneof com.seed.documents.v3alpha.DocumentChange.SetAttribute.value
   */
  value: {
    /**
     * @generated from field: string string_value = 3;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: int64 int_value = 4;
     */
    value: bigint;
    case: "intValue";
  } | {
    /**
     * @generated from field: bool bool_value = 5;
     */
    value: boolean;
    case: "boolValue";
  } | {
    /**
     * @generated from field: google.protobuf.Empty null_value = 6;
     */
    value: Empty;
    case: "nullValue";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<DocumentChange_SetAttribute>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DocumentChange.SetAttribute";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "block_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "string_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
    { no: 4, name: "int_value", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "value" },
    { no: 5, name: "bool_value", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "value" },
    { no: 6, name: "null_value", kind: "message", T: Empty, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentChange_SetAttribute {
    return new DocumentChange_SetAttribute().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentChange_SetAttribute {
    return new DocumentChange_SetAttribute().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentChange_SetAttribute {
    return new DocumentChange_SetAttribute().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentChange_SetAttribute | PlainMessage<DocumentChange_SetAttribute> | undefined, b: DocumentChange_SetAttribute | PlainMessage<DocumentChange_SetAttribute> | undefined): boolean {
    return proto3.util.equals(DocumentChange_SetAttribute, a, b);
  }
}

/**
 * Description of a Ref blob.
 *
 * @generated from message com.seed.documents.v3alpha.Ref
 */
export class Ref extends Message<Ref> {
  /**
   * CID of the Ref blob.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Account (space) in which the Ref blob exists.
   *
   * @generated from field: string account = 2;
   */
  account = "";

  /**
   * Path in the account Ref creates an entry for.
   *
   * @generated from field: string path = 3;
   */
  path = "";

  /**
   * Description of where the Ref points to.
   *
   * @generated from field: com.seed.documents.v3alpha.RefTarget target = 4;
   */
  target?: RefTarget;

  /**
   * Public key used to sign the Ref blob.
   *
   * @generated from field: string signer = 5;
   */
  signer = "";

  /**
   * Optional. ID of the Capability attached to this Ref.
   *
   * @generated from field: string capability = 6;
   */
  capability = "";

  /**
   * Timestamp of the Ref.
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 7;
   */
  timestamp?: Timestamp;

  /**
   * Information about the generation of the Ref.
   *
   * @generated from field: com.seed.documents.v3alpha.GenerationInfo generation_info = 8;
   */
  generationInfo?: GenerationInfo;

  constructor(data?: PartialMessage<Ref>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Ref";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "target", kind: "message", T: RefTarget },
    { no: 5, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "capability", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "timestamp", kind: "message", T: Timestamp },
    { no: 8, name: "generation_info", kind: "message", T: GenerationInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Ref {
    return new Ref().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Ref {
    return new Ref().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Ref {
    return new Ref().fromJsonString(jsonString, options);
  }

  static equals(a: Ref | PlainMessage<Ref> | undefined, b: Ref | PlainMessage<Ref> | undefined): boolean {
    return proto3.util.equals(Ref, a, b);
  }
}

/**
 * Description of where the Ref points to.
 *
 * @generated from message com.seed.documents.v3alpha.RefTarget
 */
export class RefTarget extends Message<RefTarget> {
  /**
   * A Ref can point to one of the following targets.
   *
   * @generated from oneof com.seed.documents.v3alpha.RefTarget.target
   */
  target: {
    /**
     * Version target describes genesis + head changes (version).
     *
     * @generated from field: com.seed.documents.v3alpha.RefTarget.Version version = 1;
     */
    value: RefTarget_Version;
    case: "version";
  } | {
    /**
     * Redirect target makes a Ref point to a different account + path.
     * Users must be careful to not create cycles or very deep redirect chains.
     * Client should be careful not to get stuck in redirects
     * by tracking visited paths to prevent cycles,
     * and by limiting the depth of the redirect chains,
     * while handling redirects.
     *
     * @generated from field: com.seed.documents.v3alpha.RefTarget.Redirect redirect = 2;
     */
    value: RefTarget_Redirect;
    case: "redirect";
  } | {
    /**
     * Tombstone Ref indicates the intent to delete the given account + path.
     *
     * @generated from field: com.seed.documents.v3alpha.RefTarget.Tombstone tombstone = 3;
     */
    value: RefTarget_Tombstone;
    case: "tombstone";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<RefTarget>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.RefTarget";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "message", T: RefTarget_Version, oneof: "target" },
    { no: 2, name: "redirect", kind: "message", T: RefTarget_Redirect, oneof: "target" },
    { no: 3, name: "tombstone", kind: "message", T: RefTarget_Tombstone, oneof: "target" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefTarget {
    return new RefTarget().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefTarget {
    return new RefTarget().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefTarget {
    return new RefTarget().fromJsonString(jsonString, options);
  }

  static equals(a: RefTarget | PlainMessage<RefTarget> | undefined, b: RefTarget | PlainMessage<RefTarget> | undefined): boolean {
    return proto3.util.equals(RefTarget, a, b);
  }
}

/**
 * @generated from message com.seed.documents.v3alpha.RefTarget.Version
 */
export class RefTarget_Version extends Message<RefTarget_Version> {
  /**
   * Required. ID of the genesis Change.
   *
   * @generated from field: string genesis = 1;
   */
  genesis = "";

  /**
   * Required. Version ID (possibly compount).
   * Each change in the version ID must have the same genesis.
   *
   * @generated from field: string version = 2;
   */
  version = "";

  constructor(data?: PartialMessage<RefTarget_Version>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.RefTarget.Version";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "genesis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefTarget_Version {
    return new RefTarget_Version().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefTarget_Version {
    return new RefTarget_Version().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefTarget_Version {
    return new RefTarget_Version().fromJsonString(jsonString, options);
  }

  static equals(a: RefTarget_Version | PlainMessage<RefTarget_Version> | undefined, b: RefTarget_Version | PlainMessage<RefTarget_Version> | undefined): boolean {
    return proto3.util.equals(RefTarget_Version, a, b);
  }
}

/**
 * @generated from message com.seed.documents.v3alpha.RefTarget.Redirect
 */
export class RefTarget_Redirect extends Message<RefTarget_Redirect> {
  /**
   * Required. Account ID to which the Ref should redirect.
   * Can be the same as the account in the Ref itself,
   * when we redirect to a different path in the same account/space.
   *
   * @generated from field: string account = 1;
   */
  account = "";

  /**
   * Required. Path to which the Ref should redirect.
   * Empty string means root document.
   * Must not be the same as the Ref itself.
   *
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * Optional. If true, the Ref becomes a republishing Ref,
   * in which case instead of explicitly redirecting to the target resource
   * it will display the target document right away, using the most recent version available.
   *
   * @generated from field: bool republish = 3;
   */
  republish = false;

  constructor(data?: PartialMessage<RefTarget_Redirect>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.RefTarget.Redirect";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "republish", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefTarget_Redirect {
    return new RefTarget_Redirect().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefTarget_Redirect {
    return new RefTarget_Redirect().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefTarget_Redirect {
    return new RefTarget_Redirect().fromJsonString(jsonString, options);
  }

  static equals(a: RefTarget_Redirect | PlainMessage<RefTarget_Redirect> | undefined, b: RefTarget_Redirect | PlainMessage<RefTarget_Redirect> | undefined): boolean {
    return proto3.util.equals(RefTarget_Redirect, a, b);
  }
}

/**
 * @generated from message com.seed.documents.v3alpha.RefTarget.Tombstone
 */
export class RefTarget_Tombstone extends Message<RefTarget_Tombstone> {
  constructor(data?: PartialMessage<RefTarget_Tombstone>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.RefTarget.Tombstone";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefTarget_Tombstone {
    return new RefTarget_Tombstone().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefTarget_Tombstone {
    return new RefTarget_Tombstone().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefTarget_Tombstone {
    return new RefTarget_Tombstone().fromJsonString(jsonString, options);
  }

  static equals(a: RefTarget_Tombstone | PlainMessage<RefTarget_Tombstone> | undefined, b: RefTarget_Tombstone | PlainMessage<RefTarget_Tombstone> | undefined): boolean {
    return proto3.util.equals(RefTarget_Tombstone, a, b);
  }
}

